import React, { useEffect, useState } from "react";
import WalletIcon from "../../images/coin/wallet-coin.png";
import Coin from "../../images/coin/coin.png";
// import "../../css/style.css";

const featuresData = [

  {
    icon: WalletIcon,
    title: "Bronze",
    // description: "20,001 to 200,000 TopCoin.",
    description: "1 to 20,000 TopCoin",
    color: "#cc874e",
    details: "Unlocks first cash rewards and additional benefits."
  },

  {
    icon: WalletIcon,
    title: "Nickel",
    // description: "200,001 to 2,000,000 TopCoin.",
    description: "20,001 to 200,000 TopCoin.",
    color: "#bdc2c5",
    details: "Access to enhanced rewards and partner discounts."
  },

  {
    icon: WalletIcon,
    title: "Titanium",
    description: (
      <>
        200,001 to 2,000,000 TopCoin.
        {/* &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; */}
        {/* <span style={{ marginRight: '30px' }}></span> */}
      </>
    ),
    color: "#727b84",
    details: "Basic wallet for new users with entry-level rewards."
  },
  // {
  //   icon: WalletIcon,
  //   title: "Bronze",
  //   description: "20,001 to 200,000 TopCoin.",
  //   color: "#cc874e",
  //   details: "Unlocks first cash rewards and additional benefits."
  // },
  // {
  //   icon: WalletIcon,
  //   title: "Nickel",
  //   description: "200,001 to 2,000,000 TopCoin.",
  //   color: "#bdc2c5",
  //   details: "Access to enhanced rewards and partner discounts."
  // },
  {
    icon: WalletIcon,
    title: "Silver",
    description: "2,000,001 to 4,000,000 TopCoin.",
    color: "#c0c0c0",
    details: "Premium benefits with higher cashback percentages."
  },

  {
    icon: WalletIcon,
    title: "Palladium",
    // description: "12,000,001 to 16,000,000 TopCoin.",
    description: "4,000,001 to 8,000,000 TopCoin.",
    color: "#727b84",
    details: "Elite status with maximum earning potential."
  },

  {
    icon: WalletIcon,
    title: "Platinum",
    // description: "4,000,001 to 8,000,000 TopCoin.",
    description: "8,000,001 to 12,000,000 TopCoin.",
    color: "#babfc2",
    details: "Exclusive offers and priority customer support."
  },
  {
    icon: WalletIcon,
    title: "Iridium",
    // description: "8,000,001 to 12,000,000 TopCoin.",
    description: "12,000,001 to 16,000,000 TopCoin.",
    color: "#727b84",
    details: "VIP treatment with personalized reward options."
  },
  // {
  //   icon: WalletIcon,
  //   title: "Palladium",
  //   description: "12,000,001 to 16,000,000 TopCoin.",
  //   color: "#727b84",
  //   details: "Elite status with maximum earning potential."
  // },
  {
    icon: WalletIcon,
    title: "Gold",
    description: "16,000,001 to 20,000,000 TopCoin.",
    color: "#f5be26",
    details: "Top-tier wallet with all premium benefits unlocked."
  }
];

const CashData = [
  {
    icon: Coin,
    title: "Reward Wallet 1",
    description: (
      <>
        Unlocks at 20,000 TopCoin.<br />
        {/* <span className="cash-amount">£ 25.00</span> */}
        <span className="cash-amount">£ ***** </span>
      </>
    ),
  },
  {
    icon: Coin,
    title: "Reward Wallet 2",
    description: (
      <>
        Unlocks at 200,000 TopCoin.<br />
        {/* <span className="cash-amount">£ 25.00</span> */}
        <span className="cash-amount">£ ***** </span>
      </>
    ),
  },
  {
    icon: Coin,
    title: "Reward Wallet 3",
    description: (
      <>
        Opens at 2,000,000 TopCoin.<br />
        <span className="cash-amount">£ ***** </span>
      </>
    ),
  },
  {
    icon: Coin,
    title: "Reward Wallet 4",
    description: (
      <>
        Opens at 4,000,000 TopCoin.<br />
        <span className="cash-amount">£ ***** </span>
      </>
    ),
  },
  {
    icon: Coin,
    title: "Reward Wallet 5",
    description: (
      <>
        Opens at 8,000,000 TopCoin.<br />
        <span className="cash-amount">£ ***** </span>
      </>
    ),
  },
  {
    icon: Coin,
    title: "Reward Wallet 6",
    description: (
      <>
        Opens at 12,000,000 TopCoin.<br />
        <span className="cash-amount">£ ***** </span>
      </>
    ),
  },
  {
    icon: Coin,
    title: "Reward Wallet 7",
    description: (
      <>
        Opens at 16,000,000 TopCoin.<br />
        <span className="cash-amount">£ ***** </span>
      </>
    ),
  },
  {
    icon: Coin,
    title: "Reward Wallet 8",
    description: (
      <>
        Unlocks at 20,000,000 TopCoin.<br />
        <span className="cash-amount">£ ***** </span>
      </>
    ),
  },
];

const bonusData = [

  {
    walletIndex: 2,
    title: 'Titanium',
    details: [
      { units: "220,000", unitValue: "£1,100", cashBonus: "100 + 1000 = 1100" },
      { units: "240,000", unitValue: "£1,200", cashBonus: "100 + 1100 = 1200" },
      { units: "260,000", unitValue: "£1,300", cashBonus: "100 + 1200 = 1300" },
      { units: "280,000", unitValue: "£1,400", cashBonus: "100 + 1300 = 1400" },
      { units: "300,000", unitValue: "£1,500", cashBonus: "100 + 1400 = 1500" },
      { units: "320,000", unitValue: "£1,600", cashBonus: "100 + 1500 = 1600" },
      { units: "340,000", unitValue: "£1,700", cashBonus: "100 + 1600 = 1700" },
      { units: "360,000", unitValue: "£1,800", cashBonus: "100 + 1700 = 1800" },
      { units: "380,000", unitValue: "£1,900", cashBonus: "100 + 1800 = 1900" },
      { units: "400,000", unitValue: "£2,000", cashBonus: "100 + 1900 = 2000" },
      { units: "420,000", unitValue: "£2,100", cashBonus: "100 + 2000 = 2100" },
      { units: "440,000", unitValue: "£2,200", cashBonus: "100 + 2100 = 2200" },
      { units: "460,000", unitValue: "£2,300", cashBonus: "100 + 2200 = 2300" },
      { units: "480,000", unitValue: "£2,400", cashBonus: "100 + 2300 = 2400" },
      { units: "500,000", unitValue: "£2,500", cashBonus: "100 + 2400 = 2500" },
      { units: "520,000", unitValue: "£2,600", cashBonus: "100 + 2500 = 2600" },
      { units: "540,000", unitValue: "£2,700", cashBonus: "100 + 2600 = 2700" },
      { units: "560,000", unitValue: "£2,800", cashBonus: "100 + 2700 = 2800" },
      { units: "580,000", unitValue: "£2,900", cashBonus: "100 + 2800 = 2900" },
      { units: "600,000", unitValue: "£3,000", cashBonus: "100 + 2900 = 3000" },
      { units: "620,000", unitValue: "£3,100", cashBonus: "100 + 3000 = 3100" },
      { units: "640,000", unitValue: "£3,200", cashBonus: "100 + 3100 = 3200" },
      { units: "660,000", unitValue: "£3,300", cashBonus: "100 + 3200 = 3300" },
      { units: "680,000", unitValue: "£3,400", cashBonus: "100 + 3300 = 3400" },
      { units: "700,000", unitValue: "£3,500", cashBonus: "100 + 3400 = 3500" },
      { units: "720,000", unitValue: "£3,600", cashBonus: "100 + 3500 = 3600" },
      { units: "740,000", unitValue: "£3,700", cashBonus: "100 + 3600 = 3700" },
      { units: "760,000", unitValue: "£3,800", cashBonus: "100 + 3700 = 3800" },
      { units: "780,000", unitValue: "£3,900", cashBonus: "100 + 3800 = 3900" },
      { units: "800,000", unitValue: "£4,000", cashBonus: "100 + 3900 = 4000" },
      { units: "820,000", unitValue: "£4,100", cashBonus: "100 + 4000 = 4100" },
      { units: "840,000", unitValue: "£4,200", cashBonus: "100 + 4100 = 4200" },
      { units: "860,000", unitValue: "£4,300", cashBonus: "100 + 4200 = 4300" },
      { units: "880,000", unitValue: "£4,400", cashBonus: "100 + 4300 = 4400" },
      { units: "900,000", unitValue: "£4,500", cashBonus: "100 + 4400 = 4500" },
      { units: "920,000", unitValue: "£4,600", cashBonus: "100 + 4500 = 4600" },
      { units: "940,000", unitValue: "£4,700", cashBonus: "100 + 4600 = 4700" },
      { units: "960,000", unitValue: "£4,800", cashBonus: "100 + 4700 = 4800" },
      { units: "980,000", unitValue: "£4,900", cashBonus: "100 + 4800 = 4900" },
      { units: "1,000,000", unitValue: "£5,000", cashBonus: "100 + 4900 = 5000" },
      { units: "1,020,000", unitValue: "£5,100", cashBonus: "100 + 5000 = 5100" },
      { units: "1,040,000", unitValue: "£5,200", cashBonus: "100 + 5100 = 5200" },
      { units: "1,060,000", unitValue: "£5,300", cashBonus: "100 + 5200 = 5300" },
      { units: "1,080,000", unitValue: "£5,400", cashBonus: "100 + 5300 = 5400" },
      { units: "1,100,000", unitValue: "£5,500", cashBonus: "100 + 5400 = 5500" },
      { units: "1,120,000", unitValue: "£5,600", cashBonus: "100 + 5500 = 5600" },
      { units: "1,140,000", unitValue: "£5,700", cashBonus: "100 + 5600 = 5700" },
      { units: "1,160,000", unitValue: "£5,800", cashBonus: "100 + 5700 = 5800" },
      { units: "1,180,000", unitValue: "£5,900", cashBonus: "100 + 5800 = 5900" },
      { units: "1,200,000", unitValue: "£6,000", cashBonus: "100 + 5900 = 6000" },
      { units: "1,220,000", unitValue: "£6,100", cashBonus: "100 + 6000 = 6100" },
      { units: "1,240,000", unitValue: "£6,200", cashBonus: "100 + 6100 = 6200" },
      { units: "1,260,000", unitValue: "£6,300", cashBonus: "100 + 6200 = 6300" },
      { units: "1,280,000", unitValue: "£6,400", cashBonus: "100 + 6300 = 6400" },
      { units: "1,300,000", unitValue: "£6,500", cashBonus: "100 + 6400 = 6500" },
      { units: "1,320,000", unitValue: "£6,600", cashBonus: "100 + 6500 = 6600" },
      { units: "1,340,000", unitValue: "£6,700", cashBonus: "100 + 6600 = 6700" },
      { units: "1,360,000", unitValue: "£6,800", cashBonus: "100 + 6700 = 6800" },
      { units: "1,380,000", unitValue: "£6,900", cashBonus: "100 + 6800 = 6900" },
      { units: "1,400,000", unitValue: "£7,000", cashBonus: "100 + 6900 = 7000" },
      { units: "1,420,000", unitValue: "£7,100", cashBonus: "100 + 7000 = 7100" },
      { units: "1,440,000", unitValue: "£7,200", cashBonus: "100 + 7100 = 7200" },
      { units: "1,460,000", unitValue: "£7,300", cashBonus: "100 + 7200 = 7300" },
      { units: "1,480,000", unitValue: "£7,400", cashBonus: "100 + 7300 = 7400" },
      { units: "1,500,000", unitValue: "£7,500", cashBonus: "100 + 7400 = 7500" },
      { units: "1,520,000", unitValue: "£7,600", cashBonus: "100 + 7500 = 7600" },
      { units: "1,540,000", unitValue: "£7,700", cashBonus: "100 + 7600 = 7700" },
      { units: "1,560,000", unitValue: "£7,800", cashBonus: "100 + 7700 = 7800" },
      { units: "1,580,000", unitValue: "£7,900", cashBonus: "100 + 7800 = 7900" },
      { units: "1,600,000", unitValue: "£8,000", cashBonus: "100 + 7900 = 8000" },
      { units: "1,620,000", unitValue: "£8,100", cashBonus: "100 + 8000 = 8100" },
      { units: "1,640,000", unitValue: "£8,200", cashBonus: "100 + 8100 = 8200" },
      { units: "1,660,000", unitValue: "£8,300", cashBonus: "100 + 8200 = 8300" },
      { units: "1,680,000", unitValue: "£8,400", cashBonus: "100 + 8300 = 8400" },
      { units: "1,700,000", unitValue: "£8,500", cashBonus: "100 + 8400 = 8500" },
      { units: "1,720,000", unitValue: "£8,600", cashBonus: "100 + 8500 = 8600" },
      { units: "1,740,000", unitValue: "£8,700", cashBonus: "100 + 8600 = 8700" },
      { units: "1,760,000", unitValue: "£8,800", cashBonus: "100 + 8700 = 8800" },
      { units: "1,780,000", unitValue: "£8,900", cashBonus: "100 + 8800 = 8900" },
      { units: "1,800,000", unitValue: "£9,000", cashBonus: "100 + 8900 = 9000" },
      { units: "1,820,000", unitValue: "£9,100", cashBonus: "100 + 9000 = 9100" },
      { units: "1,840,000", unitValue: "£9,200", cashBonus: "100 + 9100 = 9200" },
      { units: "1,860,000", unitValue: "£9,300", cashBonus: "100 + 9200 = 9300" },
      { units: "1,880,000", unitValue: "£9,400", cashBonus: "100 + 9300 = 9400" },
      { units: "1,900,000", unitValue: "£9,500", cashBonus: "100 + 9400 = 9500" },
      { units: "1,920,000", unitValue: "£9,600", cashBonus: "100 + 9500 = 9600" },
      { units: "1,940,000", unitValue: "£9,700", cashBonus: "100 + 9600 = 9700" },
      { units: "1,960,000", unitValue: "£9,800", cashBonus: "100 + 9700 = 9800" },
      { units: "1,980,000", unitValue: "£9,900", cashBonus: "100 + 9800 = 9900" },
      { units: "2,000,000", unitValue: "£10,000", cashBonus: "100 + 9900 = 10000" },
      
    ]
  },

  {
    walletIndex: 0,
    title: 'Bronze',
    details: [
      { units: "10,000 Free  Topcoin", unitValue: "£50", cashBonus: "Unlocks at 20,000 Topcoin" },
      { units: "20,000", unitValue: "£100", cashBonus: "£100" },
      
      // { units: "198,000 → 200,000", unitValue: "Plus £200", cashBonus: "£990 + £10 = £1000"},
    ]
  },

  {
    walletIndex: 1,
    title: 'Nickel',
    details: [
      { units: "40,000", unitValue: "£200", cashBonus: "£100 + £100 = £200" },
      { units: "60,000", unitValue: "£300", cashBonus: "£100 + £200 = £300" },
      { units: "80,000", unitValue: "£400", cashBonus: "£100 + £300 = £400" },
      { units: "100,000", unitValue: "£500", cashBonus: "£100 + £400 = £500" },
      { units: "120,000", unitValue: "£600", cashBonus: "£100 + £500 = £600" },
      { units: "140,000", unitValue: "£700", cashBonus: "£100 + £600 = £700" },
      { units: "160,000", unitValue: "£800", cashBonus: "£100 + £700 = £800" },
      { units: "180,000", unitValue: "£900", cashBonus: "£100 + £800 = £900" },
      { units: "200,000", unitValue: "£1,000", cashBonus: "£900 + 100 = 1000"},
      // { units: "200,000", unitValue: " ", cashBonus: " " },
      
    ]
  },

  {
    walletIndex: 3,
    title: 'Silver',
    details: [
      { units: "2,020,000", unitValue: "£10,100", cashBonus: "100 + 10000 = 10100" },
      { units: "2,040,000", unitValue: "£10,200", cashBonus: "100 + 10100 = 10200" },
      { units: "2,060,000", unitValue: "£10,300", cashBonus: "100 + 10200 = 10300" },
      { units: "2,080,000", unitValue: "£10,400", cashBonus: "100 + 10300 = 10400" },
      { units: "2,100,000", unitValue: "£10,500", cashBonus: "100 + 10400 = 10500" },
      { units: "2,120,000", unitValue: "£10,600", cashBonus: "100 + 10500 = 10600" },
      { units: "2,140,000", unitValue: "£10,700", cashBonus: "100 + 10600 = 10700" },
      { units: "2,160,000", unitValue: "£10,800", cashBonus: "100 + 10700 = 10800" },
      { units: "2,180,000", unitValue: "£10,900", cashBonus: "100 + 10800 = 10900" },
      { units: "2,200,000", unitValue: "£11,000", cashBonus: "100 + 10900 = 11000" },
      { units: "2,220,000", unitValue: "£11,100", cashBonus: "100 + 11000 = 11100" },
      { units: "2,240,000", unitValue: "£11,200", cashBonus: "100 + 11100 = 11200" },
      { units: "2,260,000", unitValue: "£11,300", cashBonus: "100 + 11200 = 11300" },
      { units: "2,280,000", unitValue: "£11,400", cashBonus: "100 + 11300 = 11400" },
      { units: "2,300,000", unitValue: "£11,500", cashBonus: "100 + 11400 = 11500" },
      { units: "2,320,000", unitValue: "£11,600", cashBonus: "100 + 11500 = 11600" },
      { units: "2,340,000", unitValue: "£11,700", cashBonus: "100 + 11600 = 11700" },
      { units: "2,360,000", unitValue: "£11,800", cashBonus: "100 + 11700 = 11800" },
      { units: "2,380,000", unitValue: "£11,900", cashBonus: "100 + 11800 = 11900" },
      { units: "2,400,000", unitValue: "£12,000", cashBonus: "100 + 11900 = 12000" },
      { units: "2,420,000", unitValue: "£12,100", cashBonus: "100 + 12000 = 12100" },
      { units: "2,440,000", unitValue: "£12,200", cashBonus: "100 + 12100 = 12200" },
      { units: "2,460,000", unitValue: "£12,300", cashBonus: "100 + 12200 = 12300" },
      { units: "2,480,000", unitValue: "£12,400", cashBonus: "100 + 12300 = 12400" },
      { units: "2,500,000", unitValue: "£12,500", cashBonus: "100 + 12400 = 12500" },
      { units: "2,520,000", unitValue: "£12,600", cashBonus: "100 + 12500 = 12600" },
      { units: "2,540,000", unitValue: "£12,700", cashBonus: "100 + 12600 = 12700" },
      { units: "2,560,000", unitValue: "£12,800", cashBonus: "100 + 12700 = 12800" },
      { units: "2,580,000", unitValue: "£12,900", cashBonus: "100 + 12800 = 12900" },
      { units: "2,600,000", unitValue: "£13,000", cashBonus: "100 + 12900 = 13000" },
      { units: "2,620,000", unitValue: "£13,100", cashBonus: "100 + 13000 = 13100" },
      { units: "2,640,000", unitValue: "£13,200", cashBonus: "100 + 13100 = 13200" },
      { units: "2,660,000", unitValue: "£13,300", cashBonus: "100 + 13200 = 13300" },
      { units: "2,680,000", unitValue: "£13,400", cashBonus: "100 + 13300 = 13400" },
      { units: "2,700,000", unitValue: "£13,500", cashBonus: "100 + 13400 = 13500" },
      { units: "2,720,000", unitValue: "£13,600", cashBonus: "100 + 13500 = 13600" },
      { units: "2,740,000", unitValue: "£13,700", cashBonus: "100 + 13600 = 13700" },
      { units: "2,760,000", unitValue: "£13,800", cashBonus: "100 + 13700 = 13800" },
      { units: "2,780,000", unitValue: "£13,900", cashBonus: "100 + 13800 = 13900" },
      { units: "2,800,000", unitValue: "£14,000", cashBonus: "100 + 13900 = 14000" },
      { units: "2,820,000", unitValue: "£14,100", cashBonus: "100 + 14000 = 14100" },
      { units: "2,840,000", unitValue: "£14,200", cashBonus: "100 + 14100 = 14200" },
      { units: "2,860,000", unitValue: "£14,300", cashBonus: "100 + 14200 = 14300" },
      { units: "2,880,000", unitValue: "£14,400", cashBonus: "100 + 14300 = 14400" },
      { units: "2,900,000", unitValue: "£14,500", cashBonus: "100 + 14400 = 14500" },
      { units: "2,920,000", unitValue: "£14,600", cashBonus: "100 + 14500 = 14600" },
      { units: "2,940,000", unitValue: "£14,700", cashBonus: "100 + 14600 = 14700" },
      { units: "2,960,000", unitValue: "£14,800", cashBonus: "100 + 14700 = 14800" },
      { units: "2,980,000", unitValue: "£14,900", cashBonus: "100 + 14800 = 14900" },
      { units: "3,000,000", unitValue: "£15,000", cashBonus: "100 + 14900 = 15000" },
      { units: "3,020,000", unitValue: "£15,100", cashBonus: "100 + 15000 = 15100" },
      { units: "3,040,000", unitValue: "£15,200", cashBonus: "100 + 15100 = 15200" },
      { units: "3,060,000", unitValue: "£15,300", cashBonus: "100 + 15200 = 15300" },
      { units: "3,080,000", unitValue: "£15,400", cashBonus: "100 + 15300 = 15400" },
      { units: "3,100,000", unitValue: "£15,500", cashBonus: "100 + 15400 = 15500" },
      { units: "3,120,000", unitValue: "£15,600", cashBonus: "100 + 15500 = 15600" },
      { units: "3,140,000", unitValue: "£15,700", cashBonus: "100 + 15600 = 15700" },
      { units: "3,160,000", unitValue: "£15,800", cashBonus: "100 + 15700 = 15800" },
      { units: "3,180,000", unitValue: "£15,900", cashBonus: "100 + 15800 = 15900" },
      { units: "3,200,000", unitValue: "£16,000", cashBonus: "100 + 15900 = 16000" },
      { units: "3,220,000", unitValue: "£16,100", cashBonus: "100 + 16000 = 16100" },
      { units: "3,240,000", unitValue: "£16,200", cashBonus: "100 + 16100 = 16200" },
      { units: "3,260,000", unitValue: "£16,300", cashBonus: "100 + 16200 = 16300" },
      { units: "3,280,000", unitValue: "£16,400", cashBonus: "100 + 16300 = 16400" },
      { units: "3,300,000", unitValue: "£16,500", cashBonus: "100 + 16400 = 16500" },
      { units: "3,320,000", unitValue: "£16,600", cashBonus: "100 + 16500 = 16600" },
      { units: "3,340,000", unitValue: "£16,700", cashBonus: "100 + 16600 = 16700" },
      { units: "3,360,000", unitValue: "£16,800", cashBonus: "100 + 16700 = 16800" },
      { units: "3,380,000", unitValue: "£16,900", cashBonus: "100 + 16800 = 16900" },
      { units: "3,400,000", unitValue: "£17,000", cashBonus: "100 + 16900 = 17000" },
      { units: "3,420,000", unitValue: "£17,100", cashBonus: "100 + 17000 = 17100" },
      { units: "3,440,000", unitValue: "£17,200", cashBonus: "100 + 17100 = 17200" },
      { units: "3,460,000", unitValue: "£17,300", cashBonus: "100 + 17200 = 17300" },
      { units: "3,480,000", unitValue: "£17,400", cashBonus: "100 + 17300 = 17400" },
      { units: "3,500,000", unitValue: "£17,500", cashBonus: "100 + 17400 = 17500" },
      { units: "3,520,000", unitValue: "£17,600", cashBonus: "100 + 17500 = 17600" },
      { units: "3,540,000", unitValue: "£17,700", cashBonus: "100 + 17600 = 17700" },
      { units: "3,560,000", unitValue: "£17,800", cashBonus: "100 + 17700 = 17800" },
      { units: "3,580,000", unitValue: "£17,900", cashBonus: "100 + 17800 = 17900" },
      { units: "3,600,000", unitValue: "£18,000", cashBonus: "100 + 17900 = 18000" },
      { units: "3,620,000", unitValue: "£18,100", cashBonus: "100 + 18000 = 18100" },
      { units: "3,640,000", unitValue: "£18,200", cashBonus: "100 + 18100 = 18200" },
      { units: "3,660,000", unitValue: "£18,300", cashBonus: "100 + 18200 = 18300" },
      { units: "3,680,000", unitValue: "£18,400", cashBonus: "100 + 18300 = 18400" },
      { units: "3,700,000", unitValue: "£18,500", cashBonus: "100 + 18400 = 18500" },
      { units: "3,720,000", unitValue: "£18,600", cashBonus: "100 + 18500 = 18600" },
      { units: "3,740,000", unitValue: "£18,700", cashBonus: "100 + 18600 = 18700" },
      { units: "3,760,000", unitValue: "£18,800", cashBonus: "100 + 18700 = 18800" },
      { units: "3,780,000", unitValue: "£18,900", cashBonus: "100 + 18800 = 18900" },
      { units: "3,800,000", unitValue: "£19,000", cashBonus: "100 + 18900 = 19000" },
      { units: "3,820,000", unitValue: "£19,100", cashBonus: "100 + 19000 = 19100" },
      { units: "3,840,000", unitValue: "£19,200", cashBonus: "100 + 19100 = 19200" },
      { units: "3,860,000", unitValue: "£19,300", cashBonus: "100 + 19200 = 19300" },
      { units: "3,880,000", unitValue: "£19,400", cashBonus: "100 + 19300 = 19400" },
      { units: "3,900,000", unitValue: "£19,500", cashBonus: "100 + 19400 = 19500" },
      { units: "3,920,000", unitValue: "£19,600", cashBonus: "100 + 19500 = 19600" },
      { units: "3,940,000", unitValue: "£19,700", cashBonus: "100 + 19600 = 19700" },
      { units: "3,960,000", unitValue: "£19,800", cashBonus: "100 + 19700 = 19800" },
      { units: "3,980,000", unitValue: "£19,900", cashBonus: "100 + 19800 = 19900" },
      { units: "4,000,000", unitValue: "£20,000", cashBonus: "100 + 19900 = 20000" },
      
    ]
  },

  {
    walletIndex: 5,
    title: 'Platinum',
    details: [
      { units: "8,020,000", unitValue: "£40,100", cashBonus: "100 + 40000 = 40100" },
      { units: "8,040,000", unitValue: "£40,200", cashBonus: "100 + 40100 = 40200" },
      { units: "8,060,000", unitValue: "£40,300", cashBonus: "100 + 40200 = 40300" },
      { units: "8,080,000", unitValue: "£40,400", cashBonus: "100 + 40300 = 40400" },
      { units: "8,100,000", unitValue: "£40,500", cashBonus: "100 + 40400 = 40500" },
      { units: "8,120,000", unitValue: "£40,600", cashBonus: "100 + 40500 = 40600" },
      { units: "8,140,000", unitValue: "£40,700", cashBonus: "100 + 40600 = 40700" },
      { units: "8,160,000", unitValue: "£40,800", cashBonus: "100 + 40700 = 40800" },
      { units: "8,180,000", unitValue: "£40,900", cashBonus: "100 + 40800 = 40900" },
      { units: "8,200,000", unitValue: "£41,000", cashBonus: "100 + 40900 = 41000" },
      { units: "8,220,000", unitValue: "£41,100", cashBonus: "100 + 41000 = 41100" },
      { units: "8,240,000", unitValue: "£41,200", cashBonus: "100 + 41100 = 41200" },
      { units: "8,260,000", unitValue: "£41,300", cashBonus: "100 + 41200 = 41300" },
      { units: "8,280,000", unitValue: "£41,400", cashBonus: "100 + 41300 = 41400" },
      { units: "8,300,000", unitValue: "£41,500", cashBonus: "100 + 41400 = 41500" },
      { units: "8,320,000", unitValue: "£41,600", cashBonus: "100 + 41500 = 41600" },
      { units: "8,340,000", unitValue: "£41,700", cashBonus: "100 + 41600 = 41700" },
      { units: "8,360,000", unitValue: "£41,800", cashBonus: "100 + 41700 = 41800" },
      { units: "8,380,000", unitValue: "£41,900", cashBonus: "100 + 41800 = 41900" },
      { units: "8,400,000", unitValue: "£42,000", cashBonus: "100 + 41900 = 42000" },
      { units: "8,420,000", unitValue: "£42,100", cashBonus: "100 + 42000 = 42100" },
      { units: "8,440,000", unitValue: "£42,200", cashBonus: "100 + 42100 = 42200" },
      { units: "8,460,000", unitValue: "£42,300", cashBonus: "100 + 42200 = 42300" },
      { units: "8,480,000", unitValue: "£42,400", cashBonus: "100 + 42300 = 42400" },
      { units: "8,500,000", unitValue: "£42,500", cashBonus: "100 + 42400 = 42500" },
      { units: "8,520,000", unitValue: "£42,600", cashBonus: "100 + 42500 = 42600" },
      { units: "8,540,000", unitValue: "£42,700", cashBonus: "100 + 42600 = 42700" },
      { units: "8,560,000", unitValue: "£42,800", cashBonus: "100 + 42700 = 42800" },
      { units: "8,580,000", unitValue: "£42,900", cashBonus: "100 + 42800 = 42900" },
      { units: "8,600,000", unitValue: "£43,000", cashBonus: "100 + 42900 = 43000" },
      { units: "8,620,000", unitValue: "£43,100", cashBonus: "100 + 43000 = 43100" },
      { units: "8,640,000", unitValue: "£43,200", cashBonus: "100 + 43100 = 43200" },
      { units: "8,660,000", unitValue: "£43,300", cashBonus: "100 + 43200 = 43300" },
      { units: "8,680,000", unitValue: "£43,400", cashBonus: "100 + 43300 = 43400" },
      { units: "8,700,000", unitValue: "£43,500", cashBonus: "100 + 43400 = 43500" },
      { units: "8,720,000", unitValue: "£43,600", cashBonus: "100 + 43500 = 43600" },
      { units: "8,740,000", unitValue: "£43,700", cashBonus: "100 + 43600 = 43700" },
      { units: "8,760,000", unitValue: "£43,800", cashBonus: "100 + 43700 = 43800" },
      { units: "8,780,000", unitValue: "£43,900", cashBonus: "100 + 43800 = 43900" },
      { units: "8,800,000", unitValue: "£44,000", cashBonus: "100 + 43900 = 44000" },
      { units: "8,820,000", unitValue: "£44,100", cashBonus: "100 + 44000 = 44100" },
      { units: "8,840,000", unitValue: "£44,200", cashBonus: "100 + 44100 = 44200" },
      { units: "8,860,000", unitValue: "£44,300", cashBonus: "100 + 44200 = 44300" },
      { units: "8,880,000", unitValue: "£44,400", cashBonus: "100 + 44300 = 44400" },
      { units: "8,900,000", unitValue: "£44,500", cashBonus: "100 + 44400 = 44500" },
      { units: "8,920,000", unitValue: "£44,600", cashBonus: "100 + 44500 = 44600" },
      { units: "8,940,000", unitValue: "£44,700", cashBonus: "100 + 44600 = 44700" },
      { units: "8,960,000", unitValue: "£44,800", cashBonus: "100 + 44700 = 44800" },
      { units: "8,980,000", unitValue: "£44,900", cashBonus: "100 + 44800 = 44900" },
      { units: "9,000,000", unitValue: "£45,000", cashBonus: "100 + 44900 = 45000" },
      { units: "9,020,000", unitValue: "£45,100", cashBonus: "100 + 45000 = 45100" },
      { units: "9,040,000", unitValue: "£45,200", cashBonus: "100 + 45100 = 45200" },
      { units: "9,060,000", unitValue: "£45,300", cashBonus: "100 + 45200 = 45300" },
      { units: "9,080,000", unitValue: "£45,400", cashBonus: "100 + 45300 = 45400" },
      { units: "9,100,000", unitValue: "£45,500", cashBonus: "100 + 45400 = 45500" },
      { units: "9,120,000", unitValue: "£45,600", cashBonus: "100 + 45500 = 45600" },
      { units: "9,140,000", unitValue: "£45,700", cashBonus: "100 + 45600 = 45700" },
      { units: "9,160,000", unitValue: "£45,800", cashBonus: "100 + 45700 = 45800" },
      { units: "9,180,000", unitValue: "£45,900", cashBonus: "100 + 45800 = 45900" },
      { units: "9,200,000", unitValue: "£46,000", cashBonus: "100 + 45900 = 46000" },
      { units: "9,220,000", unitValue: "£46,100", cashBonus: "100 + 46000 = 46100" },
      { units: "9,240,000", unitValue: "£46,200", cashBonus: "100 + 46100 = 46200" },
      { units: "9,260,000", unitValue: "£46,300", cashBonus: "100 + 46200 = 46300" },
      { units: "9,280,000", unitValue: "£46,400", cashBonus: "100 + 46300 = 46400" },
      { units: "9,300,000", unitValue: "£46,500", cashBonus: "100 + 46400 = 46500" },
      { units: "9,320,000", unitValue: "£46,600", cashBonus: "100 + 46500 = 46600" },
      { units: "9,340,000", unitValue: "£46,700", cashBonus: "100 + 46600 = 46700" },
      { units: "9,360,000", unitValue: "£46,800", cashBonus: "100 + 46700 = 46800" },
      { units: "9,380,000", unitValue: "£46,900", cashBonus: "100 + 46800 = 46900" },
      { units: "9,400,000", unitValue: "£47,000", cashBonus: "100 + 46900 = 47000" },
      { units: "9,420,000", unitValue: "£47,100", cashBonus: "100 + 47000 = 47100" },
      { units: "9,440,000", unitValue: "£47,200", cashBonus: "100 + 47100 = 47200" },
      { units: "9,460,000", unitValue: "£47,300", cashBonus: "100 + 47200 = 47300" },
      { units: "9,480,000", unitValue: "£47,400", cashBonus: "100 + 47300 = 47400" },
      { units: "9,500,000", unitValue: "£47,500", cashBonus: "100 + 47400 = 47500" },
      { units: "9,520,000", unitValue: "£47,600", cashBonus: "100 + 47500 = 47600" },
      { units: "9,540,000", unitValue: "£47,700", cashBonus: "100 + 47600 = 47700" },
      { units: "9,560,000", unitValue: "£47,800", cashBonus: "100 + 47700 = 47800" },
      { units: "9,580,000", unitValue: "£47,900", cashBonus: "100 + 47800 = 47900" },
      { units: "9,600,000", unitValue: "£48,000", cashBonus: "100 + 47900 = 48000" },
      { units: "9,620,000", unitValue: "£48,100", cashBonus: "100 + 48000 = 48100" },
      { units: "9,640,000", unitValue: "£48,200", cashBonus: "100 + 48100 = 48200" },
      { units: "9,660,000", unitValue: "£48,300", cashBonus: "100 + 48200 = 48300" },
      { units: "9,680,000", unitValue: "£48,400", cashBonus: "100 + 48300 = 48400" },
      { units: "9,700,000", unitValue: "£48,500", cashBonus: "100 + 48400 = 48500" },
      { units: "9,720,000", unitValue: "£48,600", cashBonus: "100 + 48500 = 48600" },
      { units: "9,740,000", unitValue: "£48,700", cashBonus: "100 + 48600 = 48700" },
      { units: "9,760,000", unitValue: "£48,800", cashBonus: "100 + 48700 = 48800" },
      { units: "9,780,000", unitValue: "£48,900", cashBonus: "100 + 48800 = 48900" },
      { units: "9,800,000", unitValue: "£49,000", cashBonus: "100 + 48900 = 49000" },
      { units: "9,820,000", unitValue: "£49,100", cashBonus: "100 + 49000 = 49100" },
      { units: "9,840,000", unitValue: "£49,200", cashBonus: "100 + 49100 = 49200" },
      { units: "9,860,000", unitValue: "£49,300", cashBonus: "100 + 49200 = 49300" },
      { units: "9,880,000", unitValue: "£49,400", cashBonus: "100 + 49300 = 49400" },
      { units: "9,900,000", unitValue: "£49,500", cashBonus: "100 + 49400 = 49500" },
      { units: "9,920,000", unitValue: "£49,600", cashBonus: "100 + 49500 = 49600" },
      { units: "9,940,000", unitValue: "£49,700", cashBonus: "100 + 49600 = 49700" },
      { units: "9,960,000", unitValue: "£49,800", cashBonus: "100 + 49700 = 49800" },
      { units: "9,980,000", unitValue: "£49,900", cashBonus: "100 + 49800 = 49900" },
      { units: "10,000,000", unitValue: "£50,000", cashBonus: "100 + 49900 = 50000" },
      { units: "10,020,000", unitValue: "£50,100", cashBonus: "100 + 50000 = 50100" },
      { units: "10,040,000", unitValue: "£50,200", cashBonus: "100 + 50100 = 50200" },
      { units: "10,060,000", unitValue: "£50,300", cashBonus: "100 + 50200 = 50300" },
      { units: "10,080,000", unitValue: "£50,400", cashBonus: "100 + 50300 = 50400" },
      { units: "10,100,000", unitValue: "£50,500", cashBonus: "100 + 50400 = 50500" },
      { units: "10,120,000", unitValue: "£50,600", cashBonus: "100 + 50500 = 50600" },
      { units: "10,140,000", unitValue: "£50,700", cashBonus: "100 + 50600 = 50700" },
      { units: "10,160,000", unitValue: "£50,800", cashBonus: "100 + 50700 = 50800" },
      { units: "10,180,000", unitValue: "£50,900", cashBonus: "100 + 50800 = 50900" },
      { units: "10,200,000", unitValue: "£51,000", cashBonus: "100 + 50900 = 51000" },
      { units: "10,220,000", unitValue: "£51,100", cashBonus: "100 + 51000 = 51100" },
      { units: "10,240,000", unitValue: "£51,200", cashBonus: "100 + 51100 = 51200" },
      { units: "10,260,000", unitValue: "£51,300", cashBonus: "100 + 51200 = 51300" },
      { units: "10,280,000", unitValue: "£51,400", cashBonus: "100 + 51300 = 51400" },
      { units: "10,300,000", unitValue: "£51,500", cashBonus: "100 + 51400 = 51500" },
      { units: "10,320,000", unitValue: "£51,600", cashBonus: "100 + 51500 = 51600" },
      { units: "10,340,000", unitValue: "£51,700", cashBonus: "100 + 51600 = 51700" },
      { units: "10,360,000", unitValue: "£51,800", cashBonus: "100 + 51700 = 51800" },
      { units: "10,380,000", unitValue: "£51,900", cashBonus: "100 + 51800 = 51900" },
      { units: "10,400,000", unitValue: "£52,000", cashBonus: "100 + 51900 = 52000" },
      { units: "10,420,000", unitValue: "£52,100", cashBonus: "100 + 52000 = 52100" },
      { units: "10,440,000", unitValue: "£52,200", cashBonus: "100 + 52100 = 52200" },
      { units: "10,460,000", unitValue: "£52,300", cashBonus: "100 + 52200 = 52300" },
      { units: "10,480,000", unitValue: "£52,400", cashBonus: "100 + 52300 = 52400" },
      { units: "10,500,000", unitValue: "£52,500", cashBonus: "100 + 52400 = 52500" },
      { units: "10,520,000", unitValue: "£52,600", cashBonus: "100 + 52500 = 52600" },
      { units: "10,540,000", unitValue: "£52,700", cashBonus: "100 + 52600 = 52700" },
      { units: "10,560,000", unitValue: "£52,800", cashBonus: "100 + 52700 = 52800" },
      { units: "10,580,000", unitValue: "£52,900", cashBonus: "100 + 52800 = 52900" },
      { units: "10,600,000", unitValue: "£53,000", cashBonus: "100 + 52900 = 53000" },
      { units: "10,620,000", unitValue: "£53,100", cashBonus: "100 + 53000 = 53100" },
      { units: "10,640,000", unitValue: "£53,200", cashBonus: "100 + 53100 = 53200" },
      { units: "10,660,000", unitValue: "£53,300", cashBonus: "100 + 53200 = 53300" },
      { units: "10,680,000", unitValue: "£53,400", cashBonus: "100 + 53300 = 53400" },
      { units: "10,700,000", unitValue: "£53,500", cashBonus: "100 + 53400 = 53500" },
      { units: "10,720,000", unitValue: "£53,600", cashBonus: "100 + 53500 = 53600" },
      { units: "10,740,000", unitValue: "£53,700", cashBonus: "100 + 53600 = 53700" },
      { units: "10,760,000", unitValue: "£53,800", cashBonus: "100 + 53700 = 53800" },
      { units: "10,780,000", unitValue: "£53,900", cashBonus: "100 + 53800 = 53900" },
      { units: "10,800,000", unitValue: "£54,000", cashBonus: "100 + 53900 = 54000" },
      { units: "10,820,000", unitValue: "£54,100", cashBonus: "100 + 54000 = 54100" },
      { units: "10,840,000", unitValue: "£54,200", cashBonus: "100 + 54100 = 54200" },
      { units: "10,860,000", unitValue: "£54,300", cashBonus: "100 + 54200 = 54300" },
      { units: "10,880,000", unitValue: "£54,400", cashBonus: "100 + 54300 = 54400" },
      { units: "10,900,000", unitValue: "£54,500", cashBonus: "100 + 54400 = 54500" },
      { units: "10,920,000", unitValue: "£54,600", cashBonus: "100 + 54500 = 54600" },
      { units: "10,940,000", unitValue: "£54,700", cashBonus: "100 + 54600 = 54700" },
      { units: "10,960,000", unitValue: "£54,800", cashBonus: "100 + 54700 = 54800" },
      { units: "10,980,000", unitValue: "£54,900", cashBonus: "100 + 54800 = 54900" },
      { units: "11,000,000", unitValue: "£55,000", cashBonus: "100 + 54900 = 55000" },
      { units: "11,020,000", unitValue: "£55,100", cashBonus: "100 + 55000 = 55100" },
      { units: "11,040,000", unitValue: "£55,200", cashBonus: "100 + 55100 = 55200" },
      { units: "11,060,000", unitValue: "£55,300", cashBonus: "100 + 55200 = 55300" },
      { units: "11,080,000", unitValue: "£55,400", cashBonus: "100 + 55300 = 55400" },
      { units: "11,100,000", unitValue: "£55,500", cashBonus: "100 + 55400 = 55500" },
      { units: "11,120,000", unitValue: "£55,600", cashBonus: "100 + 55500 = 55600" },
      { units: "11,140,000", unitValue: "£55,700", cashBonus: "100 + 55600 = 55700" },
      { units: "11,160,000", unitValue: "£55,800", cashBonus: "100 + 55700 = 55800" },
      { units: "11,180,000", unitValue: "£55,900", cashBonus: "100 + 55800 = 55900" },
      { units: "11,200,000", unitValue: "£56,000", cashBonus: "100 + 55900 = 56000" },
      { units: "11,220,000", unitValue: "£56,100", cashBonus: "100 + 56000 = 56100" },
      { units: "11,240,000", unitValue: "£56,200", cashBonus: "100 + 56100 = 56200" },
      { units: "11,260,000", unitValue: "£56,300", cashBonus: "100 + 56200 = 56300" },
      { units: "11,280,000", unitValue: "£56,400", cashBonus: "100 + 56300 = 56400" },
      { units: "11,300,000", unitValue: "£56,500", cashBonus: "100 + 56400 = 56500" },
      { units: "11,320,000", unitValue: "£56,600", cashBonus: "100 + 56500 = 56600" },
      { units: "11,340,000", unitValue: "£56,700", cashBonus: "100 + 56600 = 56700" },
      { units: "11,360,000", unitValue: "£56,800", cashBonus: "100 + 56700 = 56800" },
      { units: "11,380,000", unitValue: "£56,900", cashBonus: "100 + 56800 = 56900" },
      { units: "11,400,000", unitValue: "£57,000", cashBonus: "100 + 56900 = 57000" },
      { units: "11,420,000", unitValue: "£57,100", cashBonus: "100 + 57000 = 57100" },
      { units: "11,440,000", unitValue: "£57,200", cashBonus: "100 + 57100 = 57200" },
      { units: "11,460,000", unitValue: "£57,300", cashBonus: "100 + 57200 = 57300" },
      { units: "11,480,000", unitValue: "£57,400", cashBonus: "100 + 57300 = 57400" },
      { units: "11,500,000", unitValue: "£57,500", cashBonus: "100 + 57400 = 57500" },
      { units: "11,520,000", unitValue: "£57,600", cashBonus: "100 + 57500 = 57600" },
      { units: "11,540,000", unitValue: "£57,700", cashBonus: "100 + 57600 = 57700" },
      { units: "11,560,000", unitValue: "£57,800", cashBonus: "100 + 57700 = 57800" },
      { units: "11,580,000", unitValue: "£57,900", cashBonus: "100 + 57800 = 57900" },
      { units: "11,600,000", unitValue: "£58,000", cashBonus: "100 + 57900 = 58000" },
      { units: "11,620,000", unitValue: "£58,100", cashBonus: "100 + 58000 = 58100" },
      { units: "11,640,000", unitValue: "£58,200", cashBonus: "100 + 58100 = 58200" },
      { units: "11,660,000", unitValue: "£58,300", cashBonus: "100 + 58200 = 58300" },
      { units: "11,680,000", unitValue: "£58,400", cashBonus: "100 + 58300 = 58400" },
      { units: "11,700,000", unitValue: "£58,500", cashBonus: "100 + 58400 = 58500" },
      { units: "11,720,000", unitValue: "£58,600", cashBonus: "100 + 58500 = 58600" },
      { units: "11,740,000", unitValue: "£58,700", cashBonus: "100 + 58600 = 58700" },
      { units: "11,760,000", unitValue: "£58,800", cashBonus: "100 + 58700 = 58800" },
      { units: "11,780,000", unitValue: "£58,900", cashBonus: "100 + 58800 = 58900" },
      { units: "11,800,000", unitValue: "£59,000", cashBonus: "100 + 58900 = 59000" },
      { units: "11,820,000", unitValue: "£59,100", cashBonus: "100 + 59000 = 59100" },
      { units: "11,840,000", unitValue: "£59,200", cashBonus: "100 + 59100 = 59200" },
      { units: "11,860,000", unitValue: "£59,300", cashBonus: "100 + 59200 = 59300" },
      { units: "11,880,000", unitValue: "£59,400", cashBonus: "100 + 59300 = 59400" },
      { units: "11,900,000", unitValue: "£59,500", cashBonus: "100 + 59400 = 59500" },
      { units: "11,920,000", unitValue: "£59,600", cashBonus: "100 + 59500 = 59600" },
      { units: "11,940,000", unitValue: "£59,700", cashBonus: "100 + 59600 = 59700" },
      { units: "11,960,000", unitValue: "£59,800", cashBonus: "100 + 59700 = 59800" },
      { units: "11,980,000", unitValue: "£59,900", cashBonus: "100 + 59800 = 59900" },
      { units: "12,000,000", unitValue: "£60,000", cashBonus: "100 + 59900 = 60000" },
        

    ]
  },

  {
    walletIndex: 6,
    title: 'Iridium',
    details: [
      { units: "12,020,000", unitValue: "£60,100", cashBonus: "100 + 60000 = 60100" },
        { units: "12,040,000", unitValue: "£60,200", cashBonus: "100 + 60100 = 60200" },
        { units: "12,060,000", unitValue: "£60,300", cashBonus: "100 + 60200 = 60300" },
        { units: "12,080,000", unitValue: "£60,400", cashBonus: "100 + 60300 = 60400" },
        { units: "12,100,000", unitValue: "£60,500", cashBonus: "100 + 60400 = 60500" },
        { units: "12,120,000", unitValue: "£60,600", cashBonus: "100 + 60500 = 60600" },
        { units: "12,140,000", unitValue: "£60,700", cashBonus: "100 + 60600 = 60700" },
        { units: "12,160,000", unitValue: "£60,800", cashBonus: "100 + 60700 = 60800" },
        { units: "12,180,000", unitValue: "£60,900", cashBonus: "100 + 60800 = 60900" },
        { units: "12,200,000", unitValue: "£61,000", cashBonus: "100 + 60900 = 61000" },
        { units: "12,220,000", unitValue: "£61,100", cashBonus: "100 + 61000 = 61100" },
        { units: "12,240,000", unitValue: "£61,200", cashBonus: "100 + 61100 = 61200" },
        { units: "12,260,000", unitValue: "£61,300", cashBonus: "100 + 61200 = 61300" },
        { units: "12,280,000", unitValue: "£61,400", cashBonus: "100 + 61300 = 61400" },
        { units: "12,300,000", unitValue: "£61,500", cashBonus: "100 + 61400 = 61500" },
        { units: "12,320,000", unitValue: "£61,600", cashBonus: "100 + 61500 = 61600" },
        { units: "12,340,000", unitValue: "£61,700", cashBonus: "100 + 61600 = 61700" },
        { units: "12,360,000", unitValue: "£61,800", cashBonus: "100 + 61700 = 61800" },
        { units: "12,380,000", unitValue: "£61,900", cashBonus: "100 + 61800 = 61900" },
        { units: "12,400,000", unitValue: "£62,000", cashBonus: "100 + 61900 = 62000" },
        { units: "12,420,000", unitValue: "£62,100", cashBonus: "100 + 62000 = 62100" },
        { units: "12,440,000", unitValue: "£62,200", cashBonus: "100 + 62100 = 62200" },
        { units: "12,460,000", unitValue: "£62,300", cashBonus: "100 + 62200 = 62300" },
        { units: "12,480,000", unitValue: "£62,400", cashBonus: "100 + 62300 = 62400" },
        { units: "12,500,000", unitValue: "£62,500", cashBonus: "100 + 62400 = 62500" },
        { units: "12,520,000", unitValue: "£62,600", cashBonus: "100 + 62500 = 62600" },
        { units: "12,540,000", unitValue: "£62,700", cashBonus: "100 + 62600 = 62700" },
        { units: "12,560,000", unitValue: "£62,800", cashBonus: "100 + 62700 = 62800" },
        { units: "12,580,000", unitValue: "£62,900", cashBonus: "100 + 62800 = 62900" },
        { units: "12,600,000", unitValue: "£63,000", cashBonus: "100 + 62900 = 63000" },
        { units: "12,620,000", unitValue: "£63,100", cashBonus: "100 + 63000 = 63100" },
        { units: "12,640,000", unitValue: "£63,200", cashBonus: "100 + 63100 = 63200" },
        { units: "12,660,000", unitValue: "£63,300", cashBonus: "100 + 63200 = 63300" },
        { units: "12,680,000", unitValue: "£63,400", cashBonus: "100 + 63300 = 63400" },
        { units: "12,700,000", unitValue: "£63,500", cashBonus: "100 + 63400 = 63500" },
        { units: "12,720,000", unitValue: "£63,600", cashBonus: "100 + 63500 = 63600" },
        { units: "12,740,000", unitValue: "£63,700", cashBonus: "100 + 63600 = 63700" },
        { units: "12,760,000", unitValue: "£63,800", cashBonus: "100 + 63700 = 63800" },
        { units: "12,780,000", unitValue: "£63,900", cashBonus: "100 + 63800 = 63900" },
        { units: "12,800,000", unitValue: "£64,000", cashBonus: "100 + 63900 = 64000" },
        { units: "12,820,000", unitValue: "£64,100", cashBonus: "100 + 64000 = 64100" },
        { units: "12,840,000", unitValue: "£64,200", cashBonus: "100 + 64100 = 64200" },
        { units: "12,860,000", unitValue: "£64,300", cashBonus: "100 + 64200 = 64300" },
        { units: "12,880,000", unitValue: "£64,400", cashBonus: "100 + 64300 = 64400" },
        { units: "12,900,000", unitValue: "£64,500", cashBonus: "100 + 64400 = 64500" },
        { units: "12,920,000", unitValue: "£64,600", cashBonus: "100 + 64500 = 64600" },
        { units: "12,940,000", unitValue: "£64,700", cashBonus: "100 + 64600 = 64700" },
        { units: "12,960,000", unitValue: "£64,800", cashBonus: "100 + 64700 = 64800" },
        { units: "12,980,000", unitValue: "£64,900", cashBonus: "100 + 64800 = 64900" },
        { units: "13,000,000", unitValue: "£65,000", cashBonus: "100 + 64900 = 65000" },
        { units: "13,020,000", unitValue: "£65,100", cashBonus: "100 + 65000 = 65100" },
        { units: "13,040,000", unitValue: "£65,200", cashBonus: "100 + 65100 = 65200" },
        { units: "13,060,000", unitValue: "£65,300", cashBonus: "100 + 65200 = 65300" },
        { units: "13,080,000", unitValue: "£65,400", cashBonus: "100 + 65300 = 65400" },
        { units: "13,100,000", unitValue: "£65,500", cashBonus: "100 + 65400 = 65500" },
        { units: "13,120,000", unitValue: "£65,600", cashBonus: "100 + 65500 = 65600" },
        { units: "13,140,000", unitValue: "£65,700", cashBonus: "100 + 65600 = 65700" },
        { units: "13,160,000", unitValue: "£65,800", cashBonus: "100 + 65700 = 65800" },
        { units: "13,180,000", unitValue: "£65,900", cashBonus: "100 + 65800 = 65900" },
        { units: "13,200,000", unitValue: "£66,000", cashBonus: "100 + 65900 = 66000" },
        { units: "13,220,000", unitValue: "£66,100", cashBonus: "100 + 66000 = 66100" },
        { units: "13,240,000", unitValue: "£66,200", cashBonus: "100 + 66100 = 66200" },
        { units: "13,260,000", unitValue: "£66,300", cashBonus: "100 + 66200 = 66300" },
        { units: "13,280,000", unitValue: "£66,400", cashBonus: "100 + 66300 = 66400" },
        { units: "13,300,000", unitValue: "£66,500", cashBonus: "100 + 66400 = 66500" },
        { units: "13,320,000", unitValue: "£66,600", cashBonus: "100 + 66500 = 66600" },
        { units: "13,340,000", unitValue: "£66,700", cashBonus: "100 + 66600 = 66700" },
        { units: "13,360,000", unitValue: "£66,800", cashBonus: "100 + 66700 = 66800" },
        { units: "13,380,000", unitValue: "£66,900", cashBonus: "100 + 66800 = 66900" },
        { units: "13,400,000", unitValue: "£67,000", cashBonus: "100 + 66900 = 67000" },
        { units: "13,420,000", unitValue: "£67,100", cashBonus: "100 + 67000 = 67100" },
        { units: "13,440,000", unitValue: "£67,200", cashBonus: "100 + 67100 = 67200" },
        { units: "13,460,000", unitValue: "£67,300", cashBonus: "100 + 67200 = 67300" },
        { units: "13,480,000", unitValue: "£67,400", cashBonus: "100 + 67300 = 67400" },
        { units: "13,500,000", unitValue: "£67,500", cashBonus: "100 + 67400 = 67500" },
        { units: "13,520,000", unitValue: "£67,600", cashBonus: "100 + 67500 = 67600" },
        { units: "13,540,000", unitValue: "£67,700", cashBonus: "100 + 67600 = 67700" },
        { units: "13,560,000", unitValue: "£67,800", cashBonus: "100 + 67700 = 67800" },
        { units: "13,580,000", unitValue: "£67,900", cashBonus: "100 + 67800 = 67900" },
        { units: "13,600,000", unitValue: "£68,000", cashBonus: "100 + 67900 = 68000" },
        { units: "13,620,000", unitValue: "£68,100", cashBonus: "100 + 68000 = 68100" },
        { units: "13,640,000", unitValue: "£68,200", cashBonus: "100 + 68100 = 68200" },
        { units: "13,660,000", unitValue: "£68,300", cashBonus: "100 + 68200 = 68300" },
        { units: "13,680,000", unitValue: "£68,400", cashBonus: "100 + 68300 = 68400" },
        { units: "13,700,000", unitValue: "£68,500", cashBonus: "100 + 68400 = 68500" },
        { units: "13,720,000", unitValue: "£68,600", cashBonus: "100 + 68500 = 68600" },
        { units: "13,740,000", unitValue: "£68,700", cashBonus: "100 + 68600 = 68700" },
        { units: "13,760,000", unitValue: "£68,800", cashBonus: "100 + 68700 = 68800" },
        { units: "13,780,000", unitValue: "£68,900", cashBonus: "100 + 68800 = 68900" },
        { units: "13,800,000", unitValue: "£69,000", cashBonus: "100 + 68900 = 69000" },
        { units: "13,820,000", unitValue: "£69,100", cashBonus: "100 + 69000 = 69100" },
        { units: "13,840,000", unitValue: "£69,200", cashBonus: "100 + 69100 = 69200" },
        { units: "13,860,000", unitValue: "£69,300", cashBonus: "100 + 69200 = 69300" },
        { units: "13,880,000", unitValue: "£69,400", cashBonus: "100 + 69300 = 69400" },
        { units: "13,900,000", unitValue: "£69,500", cashBonus: "100 + 69400 = 69500" },
        { units: "13,920,000", unitValue: "£69,600", cashBonus: "100 + 69500 = 69600" },
        { units: "13,940,000", unitValue: "£69,700", cashBonus: "100 + 69600 = 69700" },
        { units: "13,960,000", unitValue: "£69,800", cashBonus: "100 + 69700 = 69800" },
        { units: "13,980,000", unitValue: "£69,900", cashBonus: "100 + 69800 = 69900" },
        { units: "14,000,000", unitValue: "£70,000", cashBonus: "100 + 69900 = 70000" },
        { units: "14,020,000", unitValue: "£70,100", cashBonus: "100 + 70000 = 70100" },
        { units: "14,040,000", unitValue: "£70,200", cashBonus: "100 + 70100 = 70200" },
        { units: "14,060,000", unitValue: "£70,300", cashBonus: "100 + 70200 = 70300" },
        { units: "14,080,000", unitValue: "£70,400", cashBonus: "100 + 70300 = 70400" },
        { units: "14,100,000", unitValue: "£70,500", cashBonus: "100 + 70400 = 70500" },
        { units: "14,120,000", unitValue: "£70,600", cashBonus: "100 + 70500 = 70600" },
        { units: "14,140,000", unitValue: "£70,700", cashBonus: "100 + 70600 = 70700" },
        { units: "14,160,000", unitValue: "£70,800", cashBonus: "100 + 70700 = 70800" },
        { units: "14,180,000", unitValue: "£70,900", cashBonus: "100 + 70800 = 70900" },
        { units: "14,200,000", unitValue: "£71,000", cashBonus: "100 + 70900 = 71000" },
        { units: "14,220,000", unitValue: "£71,100", cashBonus: "100 + 71000 = 71100" },
        { units: "14,240,000", unitValue: "£71,200", cashBonus: "100 + 71100 = 71200" },
        { units: "14,260,000", unitValue: "£71,300", cashBonus: "100 + 71200 = 71300" },
        { units: "14,280,000", unitValue: "£71,400", cashBonus: "100 + 71300 = 71400" },
        { units: "14,300,000", unitValue: "£71,500", cashBonus: "100 + 71400 = 71500" },
        { units: "14,320,000", unitValue: "£71,600", cashBonus: "100 + 71500 = 71600" },
        { units: "14,340,000", unitValue: "£71,700", cashBonus: "100 + 71600 = 71700" },
        { units: "14,360,000", unitValue: "£71,800", cashBonus: "100 + 71700 = 71800" },
        { units: "14,380,000", unitValue: "£71,900", cashBonus: "100 + 71800 = 71900" },
        { units: "14,400,000", unitValue: "£72,000", cashBonus: "100 + 71900 = 72000" },
        { units: "14,420,000", unitValue: "£72,100", cashBonus: "100 + 72000 = 72100" },
        { units: "14,440,000", unitValue: "£72,200", cashBonus: "100 + 72100 = 72200" },
        { units: "14,460,000", unitValue: "£72,300", cashBonus: "100 + 72200 = 72300" },
        { units: "14,480,000", unitValue: "£72,400", cashBonus: "100 + 72300 = 72400" },
        { units: "14,500,000", unitValue: "£72,500", cashBonus: "100 + 72400 = 72500" },
        { units: "14,520,000", unitValue: "£72,600", cashBonus: "100 + 72500 = 72600" },
        { units: "14,540,000", unitValue: "£72,700", cashBonus: "100 + 72600 = 72700" },
        { units: "14,560,000", unitValue: "£72,800", cashBonus: "100 + 72700 = 72800" },
        { units: "14,580,000", unitValue: "£72,900", cashBonus: "100 + 72800 = 72900" },
        { units: "14,600,000", unitValue: "£73,000", cashBonus: "100 + 72900 = 73000" },
        { units: "14,620,000", unitValue: "£73,100", cashBonus: "100 + 73000 = 73100" },
        { units: "14,640,000", unitValue: "£73,200", cashBonus: "100 + 73100 = 73200" },
        { units: "14,660,000", unitValue: "£73,300", cashBonus: "100 + 73200 = 73300" },
        { units: "14,680,000", unitValue: "£73,400", cashBonus: "100 + 73300 = 73400" },
        { units: "14,700,000", unitValue: "£73,500", cashBonus: "100 + 73400 = 73500" },
        { units: "14,720,000", unitValue: "£73,600", cashBonus: "100 + 73500 = 73600" },
        { units: "14,740,000", unitValue: "£73,700", cashBonus: "100 + 73600 = 73700" },
        { units: "14,760,000", unitValue: "£73,800", cashBonus: "100 + 73700 = 73800" },
        { units: "14,780,000", unitValue: "£73,900", cashBonus: "100 + 73800 = 73900" },
        { units: "14,800,000", unitValue: "£74,000", cashBonus: "100 + 73900 = 74000" },
        { units: "14,820,000", unitValue: "£74,100", cashBonus: "100 + 74000 = 74100" },
        { units: "14,840,000", unitValue: "£74,200", cashBonus: "100 + 74100 = 74200" },
        { units: "14,860,000", unitValue: "£74,300", cashBonus: "100 + 74200 = 74300" },
        { units: "14,880,000", unitValue: "£74,400", cashBonus: "100 + 74300 = 74400" },
        { units: "14,900,000", unitValue: "£74,500", cashBonus: "100 + 74400 = 74500" },
        { units: "14,920,000", unitValue: "£74,600", cashBonus: "100 + 74500 = 74600" },
        { units: "14,940,000", unitValue: "£74,700", cashBonus: "100 + 74600 = 74700" },
        { units: "14,960,000", unitValue: "£74,800", cashBonus: "100 + 74700 = 74800" },
        { units: "14,980,000", unitValue: "£74,900", cashBonus: "100 + 74800 = 74900" },
        { units: "15,000,000", unitValue: "£75,000", cashBonus: "100 + 74900 = 75000" },
        { units: "15,020,000", unitValue: "£75,100", cashBonus: "100 + 75000 = 75100" },
        { units: "15,040,000", unitValue: "£75,200", cashBonus: "100 + 75100 = 75200" },
        { units: "15,060,000", unitValue: "£75,300", cashBonus: "100 + 75200 = 75300" },
        { units: "15,080,000", unitValue: "£75,400", cashBonus: "100 + 75300 = 75400" },
        { units: "15,100,000", unitValue: "£75,500", cashBonus: "100 + 75400 = 75500" },
        { units: "15,120,000", unitValue: "£75,600", cashBonus: "100 + 75500 = 75600" },
        { units: "15,140,000", unitValue: "£75,700", cashBonus: "100 + 75600 = 75700" },
        { units: "15,160,000", unitValue: "£75,800", cashBonus: "100 + 75700 = 75800" },
        { units: "15,180,000", unitValue: "£75,900", cashBonus: "100 + 75800 = 75900" },
        { units: "15,200,000", unitValue: "£76,000", cashBonus: "100 + 75900 = 76000" },
        { units: "15,220,000", unitValue: "£76,100", cashBonus: "100 + 76000 = 76100" },
        { units: "15,240,000", unitValue: "£76,200", cashBonus: "100 + 76100 = 76200" },
        { units: "15,260,000", unitValue: "£76,300", cashBonus: "100 + 76200 = 76300" },
        { units: "15,280,000", unitValue: "£76,400", cashBonus: "100 + 76300 = 76400" },
        { units: "15,300,000", unitValue: "£76,500", cashBonus: "100 + 76400 = 76500" },
        { units: "15,320,000", unitValue: "£76,600", cashBonus: "100 + 76500 = 76600" },
        { units: "15,340,000", unitValue: "£76,700", cashBonus: "100 + 76600 = 76700" },
        { units: "15,360,000", unitValue: "£76,800", cashBonus: "100 + 76700 = 76800" },
        { units: "15,380,000", unitValue: "£76,900", cashBonus: "100 + 76800 = 76900" },
        { units: "15,400,000", unitValue: "£77,000", cashBonus: "100 + 76900 = 77000" },
        { units: "15,420,000", unitValue: "£77,100", cashBonus: "100 + 77000 = 77100" },
        { units: "15,440,000", unitValue: "£77,200", cashBonus: "100 + 77100 = 77200" },
        { units: "15,460,000", unitValue: "£77,300", cashBonus: "100 + 77200 = 77300" },
        { units: "15,480,000", unitValue: "£77,400", cashBonus: "100 + 77300 = 77400" },
        { units: "15,500,000", unitValue: "£77,500", cashBonus: "100 + 77400 = 77500" },
        { units: "15,520,000", unitValue: "£77,600", cashBonus: "100 + 77500 = 77600" },
        { units: "15,540,000", unitValue: "£77,700", cashBonus: "100 + 77600 = 77700" },
        { units: "15,560,000", unitValue: "£77,800", cashBonus: "100 + 77700 = 77800" },
        { units: "15,580,000", unitValue: "£77,900", cashBonus: "100 + 77800 = 77900" },
        { units: "15,600,000", unitValue: "£78,000", cashBonus: "100 + 77900 = 78000" },
        { units: "15,620,000", unitValue: "£78,100", cashBonus: "100 + 78000 = 78100" },
        { units: "15,640,000", unitValue: "£78,200", cashBonus: "100 + 78100 = 78200" },
        { units: "15,660,000", unitValue: "£78,300", cashBonus: "100 + 78200 = 78300" },
        { units: "15,680,000", unitValue: "£78,400", cashBonus: "100 + 78300 = 78400" },
        { units: "15,700,000", unitValue: "£78,500", cashBonus: "100 + 78400 = 78500" },
        { units: "15,720,000", unitValue: "£78,600", cashBonus: "100 + 78500 = 78600" },
        { units: "15,740,000", unitValue: "£78,700", cashBonus: "100 + 78600 = 78700" },
        { units: "15,760,000", unitValue: "£78,800", cashBonus: "100 + 78700 = 78800" },
        { units: "15,780,000", unitValue: "£78,900", cashBonus: "100 + 78800 = 78900" },
        { units: "15,800,000", unitValue: "£79,000", cashBonus: "100 + 78900 = 79000" },
        { units: "15,820,000", unitValue: "£79,100", cashBonus: "100 + 79000 = 79100" },
        { units: "15,840,000", unitValue: "£79,200", cashBonus: "100 + 79100 = 79200" },
        { units: "15,860,000", unitValue: "£79,300", cashBonus: "100 + 79200 = 79300" },
        { units: "15,880,000", unitValue: "£79,400", cashBonus: "100 + 79300 = 79400" },
        { units: "15,900,000", unitValue: "£79,500", cashBonus: "100 + 79400 = 79500" },
        { units: "15,920,000", unitValue: "£79,600", cashBonus: "100 + 79500 = 79600" },
        { units: "15,940,000", unitValue: "£79,700", cashBonus: "100 + 79600 = 79700" },
        { units: "15,960,000", unitValue: "£79,800", cashBonus: "100 + 79700 = 79800" },
        { units: "15,980,000", unitValue: "£79,900", cashBonus: "100 + 79800 = 79900" },
        { units: "16,000,000", unitValue: "£80,000", cashBonus: "100 + 79900 = 80000" },
      
    ]
  },

  {
    walletIndex: 4,
    title: 'Palladium',
    details: [
      { units: "4,020,000", unitValue: "£20,100", cashBonus: "100 + 20000 = 20100" },
      { units: "4,040,000", unitValue: "£20,200", cashBonus: "100 + 20100 = 20200" },
      { units: "4,060,000", unitValue: "£20,300", cashBonus: "100 + 20200 = 20300" },
      { units: "4,080,000", unitValue: "£20,400", cashBonus: "100 + 20300 = 20400" },
      { units: "4,100,000", unitValue: "£20,500", cashBonus: "100 + 20400 = 20500" },
      { units: "4,120,000", unitValue: "£20,600", cashBonus: "100 + 20500 = 20600" },
      { units: "4,140,000", unitValue: "£20,700", cashBonus: "100 + 20600 = 20700" },
      { units: "4,160,000", unitValue: "£20,800", cashBonus: "100 + 20700 = 20800" },
      { units: "4,180,000", unitValue: "£20,900", cashBonus: "100 + 20800 = 20900" },
      { units: "4,200,000", unitValue: "£21,000", cashBonus: "100 + 20900 = 21000" },
      { units: "4,220,000", unitValue: "£21,100", cashBonus: "100 + 21000 = 21100" },
      { units: "4,240,000", unitValue: "£21,200", cashBonus: "100 + 21100 = 21200" },
      { units: "4,260,000", unitValue: "£21,300", cashBonus: "100 + 21200 = 21300" },
      { units: "4,280,000", unitValue: "£21,400", cashBonus: "100 + 21300 = 21400" },
      { units: "4,300,000", unitValue: "£21,500", cashBonus: "100 + 21400 = 21500" },
      { units: "4,320,000", unitValue: "£21,600", cashBonus: "100 + 21500 = 21600" },
      { units: "4,340,000", unitValue: "£21,700", cashBonus: "100 + 21600 = 21700" },
      { units: "4,360,000", unitValue: "£21,800", cashBonus: "100 + 21700 = 21800" },
      { units: "4,380,000", unitValue: "£21,900", cashBonus: "100 + 21800 = 21900" },
      { units: "4,400,000", unitValue: "£22,000", cashBonus: "100 + 21900 = 22000" },
      { units: "4,420,000", unitValue: "£22,100", cashBonus: "100 + 22000 = 22100" },
      { units: "4,440,000", unitValue: "£22,200", cashBonus: "100 + 22100 = 22200" },
      { units: "4,460,000", unitValue: "£22,300", cashBonus: "100 + 22200 = 22300" },
      { units: "4,480,000", unitValue: "£22,400", cashBonus: "100 + 22300 = 22400" },
      { units: "4,500,000", unitValue: "£22,500", cashBonus: "100 + 22400 = 22500" },
      { units: "4,520,000", unitValue: "£22,600", cashBonus: "100 + 22500 = 22600" },
      { units: "4,540,000", unitValue: "£22,700", cashBonus: "100 + 22600 = 22700" },
      { units: "4,560,000", unitValue: "£22,800", cashBonus: "100 + 22700 = 22800" },
      { units: "4,580,000", unitValue: "£22,900", cashBonus: "100 + 22800 = 22900" },
      { units: "4,600,000", unitValue: "£23,000", cashBonus: "100 + 22900 = 23000" },
      { units: "4,620,000", unitValue: "£23,100", cashBonus: "100 + 23000 = 23100" },
      { units: "4,640,000", unitValue: "£23,200", cashBonus: "100 + 23100 = 23200" },
      { units: "4,660,000", unitValue: "£23,300", cashBonus: "100 + 23200 = 23300" },
      { units: "4,680,000", unitValue: "£23,400", cashBonus: "100 + 23300 = 23400" },
      { units: "4,700,000", unitValue: "£23,500", cashBonus: "100 + 23400 = 23500" },
      { units: "4,720,000", unitValue: "£23,600", cashBonus: "100 + 23500 = 23600" },
      { units: "4,740,000", unitValue: "£23,700", cashBonus: "100 + 23600 = 23700" },
      { units: "4,760,000", unitValue: "£23,800", cashBonus: "100 + 23700 = 23800" },
      { units: "4,780,000", unitValue: "£23,900", cashBonus: "100 + 23800 = 23900" },
      { units: "4,800,000", unitValue: "£24,000", cashBonus: "100 + 23900 = 24000" },
      { units: "4,820,000", unitValue: "£24,100", cashBonus: "100 + 24000 = 24100" },
      { units: "4,840,000", unitValue: "£24,200", cashBonus: "100 + 24100 = 24200" },
      { units: "4,860,000", unitValue: "£24,300", cashBonus: "100 + 24200 = 24300" },
      { units: "4,880,000", unitValue: "£24,400", cashBonus: "100 + 24300 = 24400" },
      { units: "4,900,000", unitValue: "£24,500", cashBonus: "100 + 24400 = 24500" },
      { units: "4,920,000", unitValue: "£24,600", cashBonus: "100 + 24500 = 24600" },
      { units: "4,940,000", unitValue: "£24,700", cashBonus: "100 + 24600 = 24700" },
      { units: "4,960,000", unitValue: "£24,800", cashBonus: "100 + 24700 = 24800" },
      { units: "4,980,000", unitValue: "£24,900", cashBonus: "100 + 24800 = 24900" },
      { units: "5,000,000", unitValue: "£25,000", cashBonus: "100 + 24900 = 25000" },
      { units: "5,020,000", unitValue: "£25,100", cashBonus: "100 + 25000 = 25100" },
      { units: "5,040,000", unitValue: "£25,200", cashBonus: "100 + 25100 = 25200" },
      { units: "5,060,000", unitValue: "£25,300", cashBonus: "100 + 25200 = 25300" },
      { units: "5,080,000", unitValue: "£25,400", cashBonus: "100 + 25300 = 25400" },
      { units: "5,100,000", unitValue: "£25,500", cashBonus: "100 + 25400 = 25500" },
      { units: "5,120,000", unitValue: "£25,600", cashBonus: "100 + 25500 = 25600" },
      { units: "5,140,000", unitValue: "£25,700", cashBonus: "100 + 25600 = 25700" },
      { units: "5,160,000", unitValue: "£25,800", cashBonus: "100 + 25700 = 25800" },
      { units: "5,180,000", unitValue: "£25,900", cashBonus: "100 + 25800 = 25900" },
      { units: "5,200,000", unitValue: "£26,000", cashBonus: "100 + 25900 = 26000" },
      { units: "5,220,000", unitValue: "£26,100", cashBonus: "100 + 26000 = 26100" },
      { units: "5,240,000", unitValue: "£26,200", cashBonus: "100 + 26100 = 26200" },
      { units: "5,260,000", unitValue: "£26,300", cashBonus: "100 + 26200 = 26300" },
      { units: "5,280,000", unitValue: "£26,400", cashBonus: "100 + 26300 = 26400" },
      { units: "5,300,000", unitValue: "£26,500", cashBonus: "100 + 26400 = 26500" },
      { units: "5,320,000", unitValue: "£26,600", cashBonus: "100 + 26500 = 26600" },
      { units: "5,340,000", unitValue: "£26,700", cashBonus: "100 + 26600 = 26700" },
      { units: "5,360,000", unitValue: "£26,800", cashBonus: "100 + 26700 = 26800" },
      { units: "5,380,000", unitValue: "£26,900", cashBonus: "100 + 26800 = 26900" },
      { units: "5,400,000", unitValue: "£27,000", cashBonus: "100 + 26900 = 27000" },
      { units: "5,420,000", unitValue: "£27,100", cashBonus: "100 + 27000 = 27100" },
      { units: "5,440,000", unitValue: "£27,200", cashBonus: "100 + 27100 = 27200" },
      { units: "5,460,000", unitValue: "£27,300", cashBonus: "100 + 27200 = 27300" },
      { units: "5,480,000", unitValue: "£27,400", cashBonus: "100 + 27300 = 27400" },
      { units: "5,500,000", unitValue: "£27,500", cashBonus: "100 + 27400 = 27500" },
      { units: "5,520,000", unitValue: "£27,600", cashBonus: "100 + 27500 = 27600" },
      { units: "5,540,000", unitValue: "£27,700", cashBonus: "100 + 27600 = 27700" },
      { units: "5,560,000", unitValue: "£27,800", cashBonus: "100 + 27700 = 27800" },
      { units: "5,580,000", unitValue: "£27,900", cashBonus: "100 + 27800 = 27900" },
      { units: "5,600,000", unitValue: "£28,000", cashBonus: "100 + 27900 = 28000" },
      { units: "5,620,000", unitValue: "£28,100", cashBonus: "100 + 28000 = 28100" },
      { units: "5,640,000", unitValue: "£28,200", cashBonus: "100 + 28100 = 28200" },
      { units: "5,660,000", unitValue: "£28,300", cashBonus: "100 + 28200 = 28300" },
      { units: "5,680,000", unitValue: "£28,400", cashBonus: "100 + 28300 = 28400" },
      { units: "5,700,000", unitValue: "£28,500", cashBonus: "100 + 28500 = 28500" },
      { units: "5,720,000", unitValue: "£28,600", cashBonus: "100 + 28500 = 28600" },
      { units: "5,740,000", unitValue: "£28,700", cashBonus: "100 + 28600 = 28700" },
      { units: "5,760,000", unitValue: "£28,800", cashBonus: "100 + 28700 = 28800" },
      { units: "5,780,000", unitValue: "£28,900", cashBonus: "100 + 28800 = 28900" },
      { units: "5,800,000", unitValue: "£29,000", cashBonus: "100 + 28900 = 29000" },
      { units: "5,820,000", unitValue: "£29,100", cashBonus: "100 + 29000 = 29100" },
      { units: "5,840,000", unitValue: "£29,200", cashBonus: "100 + 29100 = 29200" },
      { units: "5,860,000", unitValue: "£29,300", cashBonus: "100 + 29200 = 29300" },
      { units: "5,880,000", unitValue: "£29,400", cashBonus: "100 + 29300 = 29400" },
      { units: "5,900,000", unitValue: "£29,500", cashBonus: "100 + 29400 = 29500" },
      { units: "5,920,000", unitValue: "£29,600", cashBonus: "100 + 29500 = 29600" },
      { units: "5,940,000", unitValue: "£29,700", cashBonus: "100 + 29600 = 29700" },
      { units: "5,960,000", unitValue: "£29,800", cashBonus: "100 + 29700 = 29800" },
      { units: "5,980,000", unitValue: "£29,900", cashBonus: "100 + 29800 = 29900" },
      { units: "6,000,000", unitValue: "£30,000", cashBonus: "100 + 29900 = 30000" },
      { units: "6,020,000", unitValue: "£30,100", cashBonus: "100 + 30000 = 30100" },
      { units: "6,040,000", unitValue: "£30,200", cashBonus: "100 + 30100 = 30200" },
      { units: "6,060,000", unitValue: "£30,300", cashBonus: "100 + 30200 = 30300" },
      { units: "6,080,000", unitValue: "£30,400", cashBonus: "100 + 30300 = 30400" },
      { units: "6,100,000", unitValue: "£30,500", cashBonus: "100 + 30400 = 30500" },
      { units: "6,120,000", unitValue: "£30,600", cashBonus: "100 + 30500 = 30600" },
      { units: "6,140,000", unitValue: "£30,700", cashBonus: "100 + 30600 = 30700" },
      { units: "6,160,000", unitValue: "£30,800", cashBonus: "100 + 30700 = 30800" },
      { units: "6,180,000", unitValue: "£30,900", cashBonus: "100 + 30800 = 30900" },
      { units: "6,200,000", unitValue: "£31,000", cashBonus: "100 + 30900 = 31000" },
      { units: "6,220,000", unitValue: "£31,100", cashBonus: "100 + 31000 = 31100" },
      { units: "6,240,000", unitValue: "£31,200", cashBonus: "100 + 31100 = 31200" },
      { units: "6,260,000", unitValue: "£31,300", cashBonus: "100 + 31200 = 31300" },
      { units: "6,280,000", unitValue: "£31,400", cashBonus: "100 + 31300 = 31400" },
      { units: "6,300,000", unitValue: "£31,500", cashBonus: "100 + 31400 = 31500" },
      { units: "6,320,000", unitValue: "£31,600", cashBonus: "100 + 31500 = 31600" },
      { units: "6,340,000", unitValue: "£31,700", cashBonus: "100 + 31600 = 31700" },
      { units: "6,360,000", unitValue: "£31,800", cashBonus: "100 + 31700 = 31800" },
      { units: "6,380,000", unitValue: "£31,900", cashBonus: "100 + 31800 = 31900" },
      { units: "6,400,000", unitValue: "£32,000", cashBonus: "100 + 31900 = 32000" },
      { units: "6,420,000", unitValue: "£32,100", cashBonus: "100 + 32000 = 32100" },
      { units: "6,440,000", unitValue: "£32,200", cashBonus: "100 + 32100 = 32200" },
      { units: "6,460,000", unitValue: "£32,300", cashBonus: "100 + 32200 = 32300" },
      { units: "6,480,000", unitValue: "£32,400", cashBonus: "100 + 32300 = 32400" },
      { units: "6,500,000", unitValue: "£32,500", cashBonus: "100 + 32400 = 32500" },
      { units: "6,520,000", unitValue: "£32,600", cashBonus: "100 + 32500 = 32600" },
      { units: "6,540,000", unitValue: "£32,700", cashBonus: "100 + 32600 = 32700" },
      { units: "6,560,000", unitValue: "£32,800", cashBonus: "100 + 32700 = 32800" },
      { units: "6,580,000", unitValue: "£32,900", cashBonus: "100 + 32800 = 32900" },
      { units: "6,600,000", unitValue: "£33,000", cashBonus: "100 + 32900 = 33000" },
      { units: "6,620,000", unitValue: "£33,100", cashBonus: "100 + 33000 = 33100" },
      { units: "6,640,000", unitValue: "£33,200", cashBonus: "100 + 33100 = 33200" },
      { units: "6,660,000", unitValue: "£33,300", cashBonus: "100 + 33200 = 33300" },
      { units: "6,680,000", unitValue: "£33,400", cashBonus: "100 + 33300 = 33400" },
      { units: "6,700,000", unitValue: "£33,500", cashBonus: "100 + 33400 = 33500" },
      { units: "6,720,000", unitValue: "£33,600", cashBonus: "100 + 33500 = 33600" },
      { units: "6,740,000", unitValue: "£33,700", cashBonus: "100 + 33600 = 33700" },
      { units: "6,760,000", unitValue: "£33,800", cashBonus: "100 + 33700 = 33800" },
      { units: "6,780,000", unitValue: "£33,900", cashBonus: "100 + 33800 = 33900" },
      { units: "6,800,000", unitValue: "£34,000", cashBonus: "100 + 33900 = 34000" },
      { units: "6,820,000", unitValue: "£34,100", cashBonus: "100 + 34000 = 34100" },
      { units: "6,840,000", unitValue: "£34,200", cashBonus: "100 + 34100 = 34200" },
      { units: "6,860,000", unitValue: "£34,300", cashBonus: "100 + 34200 = 34300" },
      { units: "6,880,000", unitValue: "£34,400", cashBonus: "100 + 34300 = 34400" },
      { units: "6,900,000", unitValue: "£34,500", cashBonus: "100 + 34400 = 34500" },
      { units: "6,920,000", unitValue: "£34,600", cashBonus: "100 + 34500 = 34600" },
      { units: "6,940,000", unitValue: "£34,700", cashBonus: "100 + 34600 = 34700" },
      { units: "6,960,000", unitValue: "£34,800", cashBonus: "100 + 34700 = 34800" },
      { units: "6,980,000", unitValue: "£34,900", cashBonus: "100 + 34800 = 34900" },
      { units: "7,000,000", unitValue: "£35,000", cashBonus: "100 + 34900 = 35000" },
      { units: "7,020,000", unitValue: "£35,100", cashBonus: "100 + 35000 = 35100" },
      { units: "7,040,000", unitValue: "£35,200", cashBonus: "100 + 35100 = 35200" },
      { units: "7,060,000", unitValue: "£35,300", cashBonus: "100 + 35200 = 35300" },
      { units: "7,080,000", unitValue: "£35,400", cashBonus: "100 + 35300 = 35400" },
      { units: "7,100,000", unitValue: "£35,500", cashBonus: "100 + 35400 = 35500" },
      { units: "7,120,000", unitValue: "£35,600", cashBonus: "100 + 35500 = 35600" },
      { units: "7,140,000", unitValue: "£35,700", cashBonus: "100 + 35600 = 35700" },
      { units: "7,160,000", unitValue: "£35,800", cashBonus: "100 + 35700 = 35800" },
      { units: "7,180,000", unitValue: "£35,900", cashBonus: "100 + 35800 = 35900" },
      { units: "7,200,000", unitValue: "£36,000", cashBonus: "100 + 35900 = 36000" },
      { units: "7,220,000", unitValue: "£36,100", cashBonus: "100 + 36000 = 36100" },
      { units: "7,240,000", unitValue: "£36,200", cashBonus: "100 + 36100 = 36200" },
      { units: "7,260,000", unitValue: "£36,300", cashBonus: "100 + 36200 = 36300" },
      { units: "7,280,000", unitValue: "£36,400", cashBonus: "100 + 36300 = 36400" },
      { units: "7,300,000", unitValue: "£36,500", cashBonus: "100 + 36400 = 36500" },
      { units: "7,320,000", unitValue: "£36,600", cashBonus: "100 + 36500 = 36600" },
      { units: "7,340,000", unitValue: "£36,700", cashBonus: "100 + 36600 = 36700" },
      { units: "7,360,000", unitValue: "£36,800", cashBonus: "100 + 36700 = 36800" },
      { units: "7,380,000", unitValue: "£36,900", cashBonus: "100 + 36800 = 36900" },
      { units: "7,400,000", unitValue: "£37,000", cashBonus: "100 + 36900 = 37000" },
      { units: "7,420,000", unitValue: "£37,100", cashBonus: "100 + 37000 = 37100" },
      { units: "7,440,000", unitValue: "£37,200", cashBonus: "100 + 37100 = 37200" },
      { units: "7,460,000", unitValue: "£37,300", cashBonus: "100 + 37200 = 37300" },
      { units: "7,480,000", unitValue: "£37,400", cashBonus: "100 + 37300 = 37400" },
      { units: "7,500,000", unitValue: "£37,500", cashBonus: "100 + 37400 = 37500" },
      { units: "7,520,000", unitValue: "£37,600", cashBonus: "100 + 37500 = 37600" },
      { units: "7,540,000", unitValue: "£37,700", cashBonus: "100 + 37600 = 37700" },
      { units: "7,560,000", unitValue: "£37,800", cashBonus: "100 + 37700 = 37800" },
      { units: "7,580,000", unitValue: "£37,900", cashBonus: "100 + 37800 = 37900" },
      { units: "7,600,000", unitValue: "£38,000", cashBonus: "100 + 37900 = 38000" },
      { units: "7,620,000", unitValue: "£38,100", cashBonus: "100 + 38000 = 38100" },
      { units: "7,640,000", unitValue: "£38,200", cashBonus: "100 + 38100 = 38200" },
      { units: "7,660,000", unitValue: "£38,300", cashBonus: "100 + 38200 = 38300" },
      { units: "7,680,000", unitValue: "£38,400", cashBonus: "100 + 38300 = 38400" },
      { units: "7,700,000", unitValue: "£38,500", cashBonus: "100 + 38400 = 38500" },
      { units: "7,720,000", unitValue: "£38,600", cashBonus: "100 + 38500 = 38600" },
      { units: "7,740,000", unitValue: "£38,700", cashBonus: "100 + 38600 = 38700" },
      { units: "7,760,000", unitValue: "£38,800", cashBonus: "100 + 38700 = 38800" },
      { units: "7,780,000", unitValue: "£38,900", cashBonus: "100 + 38800 = 38900" },
      { units: "7,800,000", unitValue: "£39,000", cashBonus: "100 + 38900 = 39000" },
      { units: "7,820,000", unitValue: "£39,100", cashBonus: "100 + 39000 = 39100" },
      { units: "7,840,000", unitValue: "£39,200", cashBonus: "100 + 39100 = 39200" },
      { units: "7,860,000", unitValue: "£39,300", cashBonus: "100 + 39200 = 39300" },
      { units: "7,880,000", unitValue: "£39,400", cashBonus: "100 + 39300 = 39400" },
      { units: "7,900,000", unitValue: "£39,500", cashBonus: "100 + 39400 = 39500" },
      { units: "7,920,000", unitValue: "£39,600", cashBonus: "100 + 39500 = 39600" },
      { units: "7,940,000", unitValue: "£39,700", cashBonus: "100 + 39600 = 39700" },
      { units: "7,960,000", unitValue: "£39,800", cashBonus: "100 + 39700 = 39800" },
      { units: "7,980,000", unitValue: "£39,900", cashBonus: "100 + 39800 = 39900" },
      { units: "8,000,000", unitValue: "£40,000", cashBonus: "100 + 39900 = 40000" },
      

    ]
  },

  {
    walletIndex: 7,
    title: 'Gold',
    details: [
      { units: "16,020,000", unitValue: "£80,100", cashBonus: "100 + 80000 = 80100" },
      { units: "16,040,000", unitValue: "£80,200", cashBonus: "100 + 80100 = 80200" },
      { units: "16,060,000", unitValue: "£80,300", cashBonus: "100 + 80200 = 80300" },
      { units: "16,080,000", unitValue: "£80,400", cashBonus: "100 + 80300 = 80400" },
      { units: "16,100,000", unitValue: "£80,500", cashBonus: "100 + 80400 = 80500" },
      { units: "16,120,000", unitValue: "£80,600", cashBonus: "100 + 80500 = 80600" },
      { units: "16,140,000", unitValue: "£80,700", cashBonus: "100 + 80600 = 80700" },
      { units: "16,160,000", unitValue: "£80,800", cashBonus: "100 + 80700 = 80800" },
      { units: "16,180,000", unitValue: "£80,900", cashBonus: "100 + 80800 = 80900" },
      { units: "16,200,000", unitValue: "£81,000", cashBonus: "100 + 80900 = 81000" },
      { units: "16,220,000", unitValue: "£81,100", cashBonus: "100 + 81000 = 81100" },
      { units: "16,240,000", unitValue: "£81,200", cashBonus: "100 + 81100 = 81200" },
      { units: "16,260,000", unitValue: "£81,300", cashBonus: "100 + 81200 = 81300" },
      { units: "16,280,000", unitValue: "£81,400", cashBonus: "100 + 81300 = 81400" },
      { units: "16,300,000", unitValue: "£81,500", cashBonus: "100 + 81400 = 81500" },
      { units: "16,320,000", unitValue: "£81,600", cashBonus: "100 + 81500 = 81600" },
      { units: "16,340,000", unitValue: "£81,700", cashBonus: "100 + 81600 = 81700" },
      { units: "16,360,000", unitValue: "£81,800", cashBonus: "100 + 81700 = 81800" },
      { units: "16,380,000", unitValue: "£81,900", cashBonus: "100 + 81800 = 81900" },
      { units: "16,400,000", unitValue: "£82,000", cashBonus: "100 + 81900 = 82000" },
      { units: "16,420,000", unitValue: "£82,100", cashBonus: "100 + 82000 = 82100" },
      { units: "16,440,000", unitValue: "£82,200", cashBonus: "100 + 82100 = 82200" },
      { units: "16,460,000", unitValue: "£82,300", cashBonus: "100 + 82200 = 82300" },
      { units: "16,480,000", unitValue: "£82,400", cashBonus: "100 + 82300 = 82400" },
      { units: "16,500,000", unitValue: "£82,500", cashBonus: "100 + 82400 = 82500" },
      { units: "16,520,000", unitValue: "£82,600", cashBonus: "100 + 82500 = 82600" },
      { units: "16,540,000", unitValue: "£82,700", cashBonus: "100 + 82600 = 82700" },
      { units: "16,560,000", unitValue: "£82,800", cashBonus: "100 + 82700 = 82800" },
      { units: "16,580,000", unitValue: "£82,900", cashBonus: "100 + 82800 = 82900" },
      { units: "16,600,000", unitValue: "£83,000", cashBonus: "100 + 82900 = 83000" },
      { units: "16,620,000", unitValue: "£83,100", cashBonus: "100 + 83000 = 83100" },
      { units: "16,640,000", unitValue: "£83,200", cashBonus: "100 + 83100 = 83200" },
      { units: "16,660,000", unitValue: "£83,300", cashBonus: "100 + 83200 = 83300" },
      { units: "16,680,000", unitValue: "£83,400", cashBonus: "100 + 83300 = 83400" },
      { units: "16,700,000", unitValue: "£83,500", cashBonus: "100 + 83400 = 83500" },
      { units: "16,720,000", unitValue: "£83,600", cashBonus: "100 + 83500 = 83600" },
      { units: "16,740,000", unitValue: "£83,700", cashBonus: "100 + 83600 = 83700" },
      { units: "16,760,000", unitValue: "£83,800", cashBonus: "100 + 83700 = 83800" },
      { units: "16,780,000", unitValue: "£83,900", cashBonus: "100 + 83800 = 83900" },
      { units: "16,800,000", unitValue: "£84,000", cashBonus: "100 + 83900 = 84000" },
      { units: "16,820,000", unitValue: "£84,100", cashBonus: "100 + 84000 = 84100" },
      { units: "16,840,000", unitValue: "£84,200", cashBonus: "100 + 84100 = 84200" },
      { units: "16,860,000", unitValue: "£84,300", cashBonus: "100 + 84200 = 84300" },
      { units: "16,880,000", unitValue: "£84,400", cashBonus: "100 + 84300 = 84400" },
      { units: "16,900,000", unitValue: "£84,500", cashBonus: "100 + 84400 = 84500" },
      { units: "16,920,000", unitValue: "£84,600", cashBonus: "100 + 84500 = 84600" },
      { units: "16,940,000", unitValue: "£84,700", cashBonus: "100 + 84600 = 84700" },
      { units: "16,960,000", unitValue: "£84,800", cashBonus: "100 + 84700 = 84800" },
      { units: "16,980,000", unitValue: "£84,900", cashBonus: "100 + 84800 = 84900" },
      { units: "17,000,000", unitValue: "£85,000", cashBonus: "100 + 84900 = 85000" },
      { units: "17,020,000", unitValue: "£85,100", cashBonus: "100 + 85000 = 85100" },
      { units: "17,040,000", unitValue: "£85,200", cashBonus: "100 + 85100 = 85200" },
      { units: "17,060,000", unitValue: "£85,300", cashBonus: "100 + 85200 = 85300" },
      { units: "17,080,000", unitValue: "£85,400", cashBonus: "100 + 85300 = 85400" },
      { units: "17,100,000", unitValue: "£85,500", cashBonus: "100 + 85400 = 85500" },
      { units: "17,120,000", unitValue: "£85,600", cashBonus: "100 + 85500 = 85600" },
      { units: "17,140,000", unitValue: "£85,700", cashBonus: "100 + 85600 = 85700" },
      { units: "17,160,000", unitValue: "£85,800", cashBonus: "100 + 85700 = 85800" },
      { units: "17,180,000", unitValue: "£85,900", cashBonus: "100 + 85800 = 85900" },
      { units: "17,200,000", unitValue: "£86,000", cashBonus: "100 + 85900 = 86000" },
      { units: "17,220,000", unitValue: "£86,100", cashBonus: "100 + 86000 = 86100" },
      { units: "17,240,000", unitValue: "£86,200", cashBonus: "100 + 86100 = 86200" },
      { units: "17,260,000", unitValue: "£86,300", cashBonus: "100 + 86200 = 86300" },
      { units: "17,280,000", unitValue: "£86,400", cashBonus: "100 + 86300 = 86400" },
      { units: "17,300,000", unitValue: "£86,500", cashBonus: "100 + 86400 = 86500" },
      { units: "17,320,000", unitValue: "£86,600", cashBonus: "100 + 86500 = 86600" },
      { units: "17,340,000", unitValue: "£86,700", cashBonus: "100 + 86600 = 86700" },
      { units: "17,360,000", unitValue: "£86,800", cashBonus: "100 + 86700 = 86800" },
      { units: "17,380,000", unitValue: "£86,900", cashBonus: "100 + 86800 = 86900" },
      { units: "17,400,000", unitValue: "£87,000", cashBonus: "100 + 86900 = 87000" },
      { units: "17,420,000", unitValue: "£87,100", cashBonus: "100 + 87000 = 87100" },
      { units: "17,440,000", unitValue: "£87,200", cashBonus: "100 + 87100 = 87200" },
      { units: "17,460,000", unitValue: "£87,300", cashBonus: "100 + 87200 = 87300" },
      { units: "17,480,000", unitValue: "£87,400", cashBonus: "100 + 87300 = 87400" },
      { units: "17,500,000", unitValue: "£87,500", cashBonus: "100 + 87400 = 87500" },
      { units: "17,520,000", unitValue: "£87,600", cashBonus: "100 + 87500 = 87600" },
      { units: "17,540,000", unitValue: "£87,700", cashBonus: "100 + 87600 = 87700" },
      { units: "17,560,000", unitValue: "£87,800", cashBonus: "100 + 87700 = 87800" },
      { units: "17,580,000", unitValue: "£87,900", cashBonus: "100 + 87800 = 87900" },
      { units: "17,600,000", unitValue: "£88,000", cashBonus: "100 + 87900 = 88000" },
      { units: "17,620,000", unitValue: "£88,100", cashBonus: "100 + 88000 = 88100" },
      { units: "17,640,000", unitValue: "£88,200", cashBonus: "100 + 88100 = 88200" },
      { units: "17,660,000", unitValue: "£88,300", cashBonus: "100 + 88200 = 88300" },
      { units: "17,680,000", unitValue: "£88,400", cashBonus: "100 + 88300 = 88400" },
      { units: "17,700,000", unitValue: "£88,500", cashBonus: "100 + 88400 = 88500" },
      { units: "17,720,000", unitValue: "£88,600", cashBonus: "100 + 88500 = 88600" },
      { units: "17,740,000", unitValue: "£88,700", cashBonus: "100 + 88600 = 88700" },
      { units: "17,760,000", unitValue: "£88,800", cashBonus: "100 + 88700 = 88800" },
      { units: "17,780,000", unitValue: "£88,900", cashBonus: "100 + 88800 = 88900" },
      { units: "17,800,000", unitValue: "£89,000", cashBonus: "100 + 88900 = 89000" },
      { units: "17,820,000", unitValue: "£89,100", cashBonus: "100 + 89000 = 89100" },
      { units: "17,840,000", unitValue: "£89,200", cashBonus: "100 + 89100 = 89200" },
      { units: "17,860,000", unitValue: "£89,300", cashBonus: "100 + 89200 = 89300" },
      { units: "17,880,000", unitValue: "£89,400", cashBonus: "100 + 89300 = 89400" },
      { units: "17,900,000", unitValue: "£89,500", cashBonus: "100 + 89400 = 89500" },
      { units: "17,920,000", unitValue: "£89,600", cashBonus: "100 + 89500 = 89600" },
      { units: "17,940,000", unitValue: "£89,700", cashBonus: "100 + 89600 = 89700" },
      { units: "17,960,000", unitValue: "£89,800", cashBonus: "100 + 89700 = 89800" },
      { units: "17,980,000", unitValue: "£89,900", cashBonus: "100 + 89800 = 89900" },
      { units: "18,000,000", unitValue: "£90,000", cashBonus: "100 + 89900 = 90000" },
      { units: "18,020,000", unitValue: "£90,100", cashBonus: "100 + 90000 = 90100" },
      { units: "18,040,000", unitValue: "£90,200", cashBonus: "100 + 90100 = 90200" },
      { units: "18,060,000", unitValue: "£90,300", cashBonus: "100 + 90200 = 90300" },
      { units: "18,080,000", unitValue: "£90,400", cashBonus: "100 + 90300 = 90400" },
      { units: "18,100,000", unitValue: "£90,500", cashBonus: "100 + 90400 = 90500" },
      { units: "18,120,000", unitValue: "£90,600", cashBonus: "100 + 90500 = 90600" },
      { units: "18,140,000", unitValue: "£90,700", cashBonus: "100 + 90600 = 90700" },
      { units: "18,160,000", unitValue: "£90,800", cashBonus: "100 + 90700 = 90800" },
      { units: "18,180,000", unitValue: "£90,900", cashBonus: "100 + 90800 = 90900" },
      { units: "18,200,000", unitValue: "£91,000", cashBonus: "100 + 90900 = 91000" },
      { units: "18,220,000", unitValue: "£91,100", cashBonus: "100 + 91000 = 91100" },
      { units: "18,240,000", unitValue: "£91,200", cashBonus: "100 + 91100 = 91200" },
      { units: "18,260,000", unitValue: "£91,300", cashBonus: "100 + 91200 = 91300" },
      { units: "18,280,000", unitValue: "£91,400", cashBonus: "100 + 91300 = 91400" },
      { units: "18,300,000", unitValue: "£91,500", cashBonus: "100 + 91400 = 91500" },
      { units: "18,320,000", unitValue: "£91,600", cashBonus: "100 + 91500 = 91600" },
      { units: "18,340,000", unitValue: "£91,700", cashBonus: "100 + 91600 = 91700" },
      { units: "18,360,000", unitValue: "£91,800", cashBonus: "100 + 91700 = 91800" },
      { units: "18,380,000", unitValue: "£91,900", cashBonus: "100 + 91800 = 91900" },
      { units: "18,400,000", unitValue: "£92,000", cashBonus: "100 + 91900 = 92000" },
      { units: "18,420,000", unitValue: "£92,100", cashBonus: "100 + 92000 = 92100" },
      { units: "18,440,000", unitValue: "£92,200", cashBonus: "100 + 92100 = 92200" },
      { units: "18,460,000", unitValue: "£92,300", cashBonus: "100 + 92200 = 92300" },
      { units: "18,480,000", unitValue: "£92,400", cashBonus: "100 + 92300 = 92400" },
      { units: "18,500,000", unitValue: "£92,500", cashBonus: "100 + 92400 = 92500" },
      { units: "18,520,000", unitValue: "£92,600", cashBonus: "100 + 92500 = 92600" },
      { units: "18,540,000", unitValue: "£92,700", cashBonus: "100 + 92600 = 92700" },
      { units: "18,560,000", unitValue: "£92,800", cashBonus: "100 + 92700 = 92800" },
      { units: "18,580,000", unitValue: "£92,900", cashBonus: "100 + 92800 = 92900" },
      { units: "18,600,000", unitValue: "£93,000", cashBonus: "100 + 92900 = 93000" },
      { units: "18,620,000", unitValue: "£93,100", cashBonus: "100 + 93000 = 93100" },
      { units: "18,640,000", unitValue: "£93,200", cashBonus: "100 + 93100 = 93200" },
      { units: "18,660,000", unitValue: "£93,300", cashBonus: "100 + 93200 = 93300" },
      { units: "18,680,000", unitValue: "£93,400", cashBonus: "100 + 93300 = 93400" },
      { units: "18,700,000", unitValue: "£93,500", cashBonus: "100 + 93400 = 93500" },
      { units: "18,720,000", unitValue: "£93,600", cashBonus: "100 + 93500 = 93600" },
      { units: "18,740,000", unitValue: "£93,700", cashBonus: "100 + 93600 = 93700" },
      { units: "18,760,000", unitValue: "£93,800", cashBonus: "100 + 93700 = 93800" },
      { units: "18,780,000", unitValue: "£93,900", cashBonus: "100 + 93800 = 93900" },
      { units: "18,800,000", unitValue: "£94,000", cashBonus: "100 + 93900 = 94000" },
      { units: "18,820,000", unitValue: "£94,100", cashBonus: "100 + 94000 = 94100" },
      { units: "18,840,000", unitValue: "£94,200", cashBonus: "100 + 94100 = 94200" },
      { units: "18,860,000", unitValue: "£94,300", cashBonus: "100 + 94200 = 94300" },
      { units: "18,880,000", unitValue: "£94,400", cashBonus: "100 + 94300 = 94400" },
      { units: "18,900,000", unitValue: "£94,500", cashBonus: "100 + 94400 = 94500" },
      { units: "18,920,000", unitValue: "£94,600", cashBonus: "100 + 94500 = 94600" },
      { units: "18,940,000", unitValue: "£94,700", cashBonus: "100 + 94600 = 94700" },
      { units: "18,960,000", unitValue: "£94,800", cashBonus: "100 + 94700 = 94800" },
      { units: "18,980,000", unitValue: "£94,900", cashBonus: "100 + 94800 = 94900" },
      { units: "19,000,000", unitValue: "£95,000", cashBonus: "100 + 94900 = 95000" },
      { units: "19,020,000", unitValue: "£95,100", cashBonus: "100 + 95000 = 95100" },
      { units: "19,040,000", unitValue: "£95,200", cashBonus: "100 + 95100 = 95200" },
      { units: "19,060,000", unitValue: "£95,300", cashBonus: "100 + 95200 = 95300" },
      { units: "19,080,000", unitValue: "£95,400", cashBonus: "100 + 95300 = 95400" },
      { units: "19,100,000", unitValue: "£95,500", cashBonus: "100 + 95400 = 95500" },
      { units: "19,120,000", unitValue: "£95,600", cashBonus: "100 + 95500 = 95600" },
      { units: "19,140,000", unitValue: "£95,700", cashBonus: "100 + 95600 = 95700" },
      { units: "19,160,000", unitValue: "£95,800", cashBonus: "100 + 95700 = 95800" },
      { units: "19,180,000", unitValue: "£95,900", cashBonus: "100 + 95800 = 95900" },
      { units: "19,200,000", unitValue: "£96,000", cashBonus: "100 + 95900 = 96000" },
      { units: "19,220,000", unitValue: "£96,100", cashBonus: "100 + 96000 = 96100" },
      { units: "19,240,000", unitValue: "£96,200", cashBonus: "100 + 96100 = 96200" },
      { units: "19,260,000", unitValue: "£96,300", cashBonus: "100 + 96200 = 96300" },
      { units: "19,280,000", unitValue: "£96,400", cashBonus: "100 + 96300 = 96400" },
      { units: "19,300,000", unitValue: "£96,500", cashBonus: "100 + 96400 = 96500" },
      { units: "19,320,000", unitValue: "£96,600", cashBonus: "100 + 96500 = 96600" },
      { units: "19,340,000", unitValue: "£96,700", cashBonus: "100 + 96600 = 96700" },
      { units: "19,360,000", unitValue: "£96,800", cashBonus: "100 + 96700 = 96800" },
      { units: "19,380,000", unitValue: "£96,900", cashBonus: "100 + 96800 = 96900" },
      { units: "19,400,000", unitValue: "£97,000", cashBonus: "100 + 96900 = 97000" },
      { units: "19,420,000", unitValue: "£97,100", cashBonus: "100 + 97000 = 97100" },
      { units: "19,440,000", unitValue: "£97,200", cashBonus: "100 + 97100 = 97200" },
      { units: "19,460,000", unitValue: "£97,300", cashBonus: "100 + 97200 = 97300" },
      { units: "19,480,000", unitValue: "£97,400", cashBonus: "100 + 97300 = 97400" },
      { units: "19,500,000", unitValue: "£97,500", cashBonus: "100 + 97400 = 97500" },
      { units: "19,520,000", unitValue: "£97,600", cashBonus: "100 + 97500 = 97600" },
      { units: "19,540,000", unitValue: "£97,700", cashBonus: "100 + 97600 = 97700" },
      { units: "19,560,000", unitValue: "£97,800", cashBonus: "100 + 97700 = 97800" },
      { units: "19,580,000", unitValue: "£97,900", cashBonus: "100 + 97800 = 97900" },
      { units: "19,600,000", unitValue: "£98,000", cashBonus: "100 + 97900 = 98000" },
      { units: "19,620,000", unitValue: "£98,100", cashBonus: "100 + 98000 = 98100" },
      { units: "19,640,000", unitValue: "£98,200", cashBonus: "100 + 98100 = 98200" },
      { units: "19,660,000", unitValue: "£98,300", cashBonus: "100 + 98200 = 98300" },
      { units: "19,680,000", unitValue: "£98,400", cashBonus: "100 + 98300 = 98400" },
      { units: "19,700,000", unitValue: "£98,500", cashBonus: "100 + 98400 = 98500" },
      { units: "19,720,000", unitValue: "£98,600", cashBonus: "100 + 98500 = 98600" },
      { units: "19,740,000", unitValue: "£98,700", cashBonus: "100 + 98600 = 98700" },
      { units: "19,760,000", unitValue: "£98,800", cashBonus: "100 + 98700 = 98800" },
      { units: "19,780,000", unitValue: "£98,900", cashBonus: "100 + 98800 = 98900" },
      { units: "19,800,000", unitValue: "£99,000", cashBonus: "100 + 98900 = 99000" },
      { units: "19,820,000", unitValue: "£99,100", cashBonus: "100 + 99000 = 99100" },
      { units: "19,840,000", unitValue: "£99,200", cashBonus: "100 + 99100 = 99200" },
      { units: "19,860,000", unitValue: "£99,300", cashBonus: "100 + 99200 = 99300" },
      { units: "19,880,000", unitValue: "£99,400", cashBonus: "100 + 99300 = 99400" },
      { units: "19,900,000", unitValue: "£99,500", cashBonus: "100 + 99400 = 99500" },
      { units: "19,920,000", unitValue: "£99,600", cashBonus: "100 + 99500 = 99600" },
      { units: "19,940,000", unitValue: "£99,700", cashBonus: "100 + 99600 = 99700" },
      { units: "19,960,000", unitValue: "£99,800", cashBonus: "100 + 99700 = 99800" },
      { units: "19,980,000", unitValue: "£99,900", cashBonus: "100 + 99800 = 99900" },
      { units: "20,000,000", unitValue: "£100,000", cashBonus: "100 + 99900 = 100000" },
    ]
  },
  
];

const MyWallet = () => {
  // const [expandedUnits, setExpandedUnits] = useState([]);


  const [activeIndex, setActiveIndex] = useState(null);

  const [showModal, setShowModal] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const selectedBonus = bonusData.find(
    (item) => item.walletIndex === activeIndex
  )?.details || [];

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleViewBonus = (index) => {
    setActiveIndex(index);
    if (isMobile) setShowModal(true);
  };

  const handleClose = () => {
    setActiveIndex(null);
    setShowModal(false);
  };

  // const toggleUnitsAccordion = (index) => {
  //   setExpandedUnits(prev => 
  //     prev.includes(index) 
  //       ? prev.filter(i => i !== index)
  //       : [...prev, index]
  //   );
  // };

  return (
    <section
      id="id_ico_tokenomics_section"
      className="ico_tokenomics_section bg-light-subtle section_space pb-5"
    >
      <div className="container">
        {/* Headers */}
        <div className="wallet-row mb-4 ">
          <div className="col-lg-6 wallet-col-6 text-center ">
            <h2 className="text-dark d-flex flex-column opacity-75">
              TopCoins{" "}
              <div className="text-center">
                <img src={Coin} width={100} alt="Coin" />
              </div>
            </h2>
          </div>
          <div className="col-lg-6 wallet-col-6 text-center">
            <h2 className="text-dark d-flex flex-column opacity-75">
              TopCoin Reward Wallets{" "}
              <div className="text-center">
                <img src={WalletIcon} width={100} alt="Wallet" />
              </div>
            </h2>
          </div>
        </div>

        {/* Wallet Rows */}
        {activeIndex === null ? (
          featuresData.map((feature, index) => (
            <div className="wallet-row mb-3" key={index}>
              {/* UNIT WALLET */}
              <div className="col-lg-6 wallet-col-6 position-relative wallet-box z-1">
                <div className="ico_iconbox_icon_left d-flex flex-lg-nowrap justify-content-center justify-content-lg-start flex-wrap shadow-sm align-items-center h-100 position-relative p-4">
                  <div className="d-flex align-items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="70" height="70">
                      <polygon points="50,5 90,25 90,75 50,95 10,75 10,25" fill={feature.color} />
                    </svg>
                    <div className="iconbox_description text-dark ms-3">
                      <h4 className="iconbox_title mb-1">{feature.title}</h4>
                      <p className="iconbox_description text-dark mb-0">
                        {feature.description}
                      </p>
                    </div>
                  </div>
                  <button className="bonus" onClick={() => handleViewBonus(index)}>
                    View Reward
                  </button>
                </div>
              </div>

              {/* CASH WALLET */}
              <div className="col-lg-6 walllet-col-6 position-relative wallet-box z-1">
                <div className="ico_iconbox_icon_left d-flex min-h200 flex-lg-nowrap justify-content-center justify-content-lg-start flex-wrap shadow-sm align-items-center h-100">
                  <div className="iconbox_info text-start w-100">
                    <h4 className="iconbox_title mb-0">{CashData[index]?.title}</h4>
                    <p className="iconbox_description text-dark mb-0">
                      {CashData[index]?.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))
        ) : (
          /* Desktop inline table view */
          !isMobile && (
            <div className="wallet-row mb-3">
              <div className="col-lg-6 wallet-col-6 wallet-box">
                <div className="ico_iconbox_icon_left d-flex flex-lg-nowrap justify-content-center justify-content-lg-start flex-wrap shadow-sm align-items-center h-100 position-relative p-4">
                  <div className="d-flex align-items-center">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" width="70" height="70">
                      <polygon
                        points="50,5 90,25 90,75 50,95 10,75 10,25"
                        fill={featuresData[activeIndex].color}
                      />
                    </svg>
                    <div className="iconbox_description text-dark ms-3">
                      <h4 className="iconbox_title mb-1">
                        {featuresData[activeIndex].title}
                      </h4>
                      <p className="iconbox_description text-dark mb-0">
                        {featuresData[activeIndex].description}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 wallet-col-6 wallet-box z-1">
                <div className="ico_iconbox_icon_left d-flex flex-column align-items-center rounded shadow p-2">
                  <div className="heading text-dark">TCUK Bonus</div>
                  <button className="closes-btn text-dark" onClick={handleClose}>
                    <u>Back</u>
                  </button>

                  <div className="table-container">
                    <table className="bonus-table">
                      <thead>
                        <tr>
                          <th>TopCoins</th>
                          <th>Value</th>
                          <th>Reward Bonus</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedBonus.map((row, idx) => (
                          <tr key={idx}>
                            <td>{row.units}</td>
                            <td>{row.unitValue}</td>
                            <td>{row.cashBonus}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          )
        )}

        {/* Mobile Modal */}
        {isMobile && showModal && (
          <div className="modal-overlay" onClick={handleClose}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <div className="heading text-dark">TCUK Bonus</div>
              <div className="coin-heading text-dark">
                {featuresData[activeIndex].title} 
              </div>
                  <button className="closes-btn text-dark" onClick={handleClose}>
                    <u>Back</u>
                  </button>
              {/* <button className="closes-btn" onClick={handleClose}>
                Back
              </button>
              <h4 className="text-center mb-3">Bonus Details</h4> */}
              <div className="table-container">
                <table className="bonus-table">
                  <thead>
                    <tr>
                      <th>TopCoins</th>
                      <th>Value</th>
                      <th>Cash Bonus</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedBonus.map((row, idx) => (
                      <tr key={idx}>
                        <td>{row.units}</td>
                        <td>{row.unitValue}</td>
                        <td>{row.cashBonus}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}
      </div>

      <style jsx>{`
        
        /* ==============================
          WALLET SECTION SCOPED STYLES
          ============================== */
        #id_ico_tokenomics_section .wallet-row {
          display: flex;
          flex-wrap: nowrap;
          align-items: stretch;
          gap: 20px;
          // text-decoration: none;
        }

        #id_ico_tokenomics_section .wallet-box {
          // flex: 1 1 50%;
          justify-content: stretch;
          display: flex;
          flex-direction: column;
          height: 100%;
        }

        #id_ico_tokenomics_section .min-h200 {
          min-height: 120px;
        }

        #id_ico_tokenomics_section .ico_iconbox_icon_left {
          border-radius: 12px;
          padding: 20px;
          // background: white;
          height: 100%;
          transition: all 0.3s ease;
          position: relative;
          display: flex;
          justify-content: space-between;
          // flex-direction: column;
          // box-sizing: border-box;
        }

        #id_ico_tokenomics_section .heading {
          position: relative;
          top: 10px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          width: 100%;
          font-size: 20px;
          font-weight: 500;
          color: #111;
          background: transparent;
          border: none;
          cursor: pointer;
          transition: color 0.2s ease;
          margin: 10px 0 15px 15px;
        }

        #id_ico_tokenomics_section .ico_iconbox_icon_left h4 {
          top: 30px;
        }

        #id_ico_tokenomics_section .col-lg-6,
        #id_ico_tokenomics_section .wallet-col-6 {
          flex: 1 1 50%;
          max-width: 100%;
          align-items: stretch;
          padding: 0;
        }

        #id_ico_tokenomics_section .wallet-box {
          height: 100%;
          flex-wrap: nowrap;
        }

        // #id_ico_tokenomics_section .unordered_list_block {
        //   height: 100%;
        // }

        // #id_ico_tokenomics_section .unordered_list_block li {
        //   height: 100%;
        // }

        /* Polygon Icon */
        #id_ico_tokenomics_section .iconbox_icon {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 100%;
          flex-shrink: 0;
        }

        /* Arrow Animations */
        #id_ico_tokenomics_section .icon_arrow {
          transition: all 0.3s ease;
        }

        #id_ico_tokenomics_section .arrow-path {
          fill: #1e40af;
          transition: all 0.3s ease;
        }

        #id_ico_tokenomics_section .icon_arrow:not(.active) .arrow-path {
          fill: #1e40af;
        }

        #id_ico_tokenomics_section .icon_arrow.active {
          transform: scaleY(-1);
        }

        #id_ico_tokenomics_section .icon_arrow.active .arrow-path {
          fill: #ffffff;
          stroke: #1e40af;
          stroke-width: 1.5;
        }

        #id_ico_tokenomics_section .cash-amount {
          font-weight: bold;
          color: #28a745;
        }

        #id_ico_tokenomics_section .closes-btn {
          position: absolute;
          top: 25px;
          right: 7px;
          background: transparent;
          border: none;
          font-size: 20px;
          font-weight: 500;
          cursor: pointer;
          color: #111;
          transition: color 0.2s;
        }

        #id_ico_tokenomics_section .bonus {
          background: none;
          border: none;
          color: #007bff;
          font-weight: 600;
          cursor: pointer;
          position: absolute;
          right: 20px;
          top: 45px;
          transition: color 0.3s ease;
          margin-top: auto;
        }

        #id_ico_tokenomics_section .table-container {
          max-height: 229px;
          overflow-y: auto;
          border-radius: 8px;
        }

        #id_ico_tokenomics_section .bonus-table {
          width: 100%;
          border-collapse: collapse;
          background-color: white;
        }

        #id_ico_tokenomics_section .bonus-table th,
        #id_ico_tokenomics_section .bonus-table td {
          border: 1px solid #ddd;
          text-align: center;
          padding: 8px;
          background-color: white;
          color: #333;
          font-size: 14px;
        }

        #id_ico_tokenomics_section .bonus-table th {
          position: sticky;
          top: 0;
          background-color: #f8f9fa;
          font-weight: 600;
        }

        .modal-overlay {
          position: fixed;
          inset: 0;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 9999;
        }

        .modal-content {
          background: white;
          border-radius: 12px;
          padding: 20px;
          max-width: 90%;
          width: 400px;
          max-height: 80vh;
          overflow-y: auto;
          position: relative;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
          animation: slideUp 0.4s ease;
        }

        @keyframes slideUp {
          from {
            transform: translateY(50px);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }

        /* ===============================
          RESPONSIVE (Mobile Styles)
          =============================== */
        @media (max-width: 768px) {
          #id_ico_tokenomics_section .min-h200 {
            min-height: 200px;
          }

          // #id_ico_tokenomics_section .navbar .login-btn {
          //   position: absolute; /* take out of normal flow */
          //   right: 15px;        /* distance from right edge */
          //   top: 20px;           /* vertical center */
          //   transform: translateY(-50%); /* perfect vertical center */
          //   display: flex;
          //   align-items: center;
          //   justify-content: center;
          // }

          #id_ico_tokenomics_section .wallet-row {
            flex-wrap: wrap;
            gap: 5px;
          }

          #id_ico_tokenomics_section .wallet-row.mb-4 {
            flex-wrap: nowrap;
            gap: 5px;
          }

          #id_ico_tokenomics_section .col-lg-6,
          #id_ico_tokenomics_section .wallet-col-6 {
            max-width: 100%;
            flex-direction: column;
          }

          #id_ico_tokenomics_section .ico_iconbox_icon_left {
            // flex-direction: column;
            // font-size: 14px;
            // height: 100%;
            flex-direction: column;
            // display: flex;
            // justify-content: space-between;
            align-items: center;
            padding: 15px 15px;  /* ✅ consistent inner spacing */
            font-size: 14px;
            // background: white;
            border-radius: 12px;
            height: 100%;
            // box-sizing: border-box;
          }

          #id_ico_tokenomics_section .ico_iconbox_icon_left h3 {
            font-size: 12px;
          }

          #id_ico_tokenomics_section .bonus {
            bottom: -85px;
            right: 31px;
            font-size: 14px;
          }

          #id_ico_tokenomics_section .closes-btn {
            top: 23px;
            right: 18px;
            font-size: 12px;
          }

          #id_ico_tokenomics_section .heading {
            top: -6px;
            margin-left: 4px;
            font-size: 12px;
          }

          #id_ico_tokenomics_section .coin-heading{
            top: 0;
            margin-left: 120px;
            font-size: 15px;
            font-weight: 600;
          }

          #id_ico_tokenomics_section .bonus-table th,
          #id_ico_tokenomics_section .bonus-table td {
            font-size: 10px;
            padding: 7px;
          }

          #id_ico_tokenomics_section .table-container {
            max-height: 180px;
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;
          }

          #id_ico_tokenomics_section .wallet-row.mb-3 {
            margin-left: 0;
            margin-right: 0;
            display: flex;
            flex-wrap: nowrap;
            gap: 10px;
            align-items: stretch;
          }

          #id_ico_tokenomics_section .wallet-row.mb-3 > .wallet-box {
            flex: 1 1 50%;
            max-width: 50%;
            display: flex;
            flex-direction: column;
            height: 200px;
            box-sizing: border-box;
          }

          #id_ico_tokenomics_section .wallet-row.mb-3 > .wallet-box:first-child {
            padding-left: 2px;
            padding-right: 2px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
          }

          #id_ico_tokenomics_section .wallet-row.mb-3 > .wallet-box:last-child {
            padding-left: 2px;
            padding-right: 2px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
          }
        }

        @media (min-width: 769px) {
          #id_ico_tokenomics_section .min-h200 {
            min-height: 120px;
          }
        }


        

        // .wallet-row {
        //   display: flex;
        //   flex-wrap: nowrap;
        //   align-items: stretch; /* ✅ force equal height */
        //   gap: 20px;
        // }

        // .wallet-box {
        //   display: flex;
        //   flex-direction: column;
        //   height: 100%;
        // }

        // .min-h200 {
        //   min-height: 120px;
        // }
        // .ico_iconbox_icon_left {
        //   border-radius: 12px;
        //   padding: 20px;
        //   background: white;
        //   height: 100%;
        //   transition: all 0.3s ease;
        //   position: relative;
        //   display: flex;
        //   justify-content: space-between;
        //   // flex-direction: column;
        // }

        // .heading{
        //   position: relative;       /* remove absolute positioning */
        //   top:15px;
        //   display: flex;
        //   justify-content: flex-start; /* ✅ align to left */
        //   align-items: center;
        //   width: 100%;
        //   font-size: 20px;
        //   font-weight: 500;
        //   color: #111;
        //   background: transparent;
        //   border: none;
        //   cursor: pointer;
        //   transition: color 0.2s ease;
        //   margin: 10px 0 15px 15px; 
        // }

        // .ico_iconbox_icon_left h4{
        //   // text-align:center;
        //   // color: #000;
        //   top:30px;
        // }

        // .col-lg-6,
        // .wallet-col-6 {
        //   flex: 1 1 50%;
        //   max-width: 100%;
        //   // display: flex;
        //   align-items: stretch;
        //   padding: 0;
        //   // flex-wrap: nowrap;
          
        // }

        // .wallet-box {
        //   height: 100%;
        //   flex-wrap: nowrap;
        // }

        // // .row.mb-3 > .wallet-box {
        // //   display: flex;
        // //   flex-direction: column;
        // //   height: 100%;
        // // }

        // .unordered_list_block {
        //   height: 100%;
        // }
        // .unordered_list_block li {
        //   height: 100%;
        // }
        
        // /* Center the polygon icon vertically */
        // .iconbox_icon {
        //   display: flex;
        //   align-items: center;
        //   justify-content: center;
        //   height: 100%;
        //   flex-shrink: 0;
        // }
        
        // /* Arrow Styles */
        // .icon_arrow {
        //   transition: all 0.3s ease;
        // }
        
        // .arrow-path {
        //   fill: #1e40af; /* Dark blue default */
        //   transition: all 0.3s ease;
        // }
        
        // /* Default state (collapsed) - pointing down with dark blue */
        // .icon_arrow:not(.active) .arrow-path {
        //   fill: #1e40af; /* Dark blue */
        // }
        
        // /* Active state (expanded) - pointing up with white fill and dark blue outline */
        // .icon_arrow.active {
        //   transform: scaleY(-1); /* Flip vertically */
        // }
        
        // .icon_arrow.active .arrow-path {
        //   fill: #ffffff; /* White fill when active */
        //   stroke: #1e40af; /* Dark blue outline */
        //   stroke-width: 1.5;
        // }
        
        // .cash-amount {
        //   font-weight: bold;
        //   color: #28a745;
        // }

      

        // .closes-btn {
        //   position: absolute;
        //   top: 33px;
        //   right: 7px;
        //   // left:100px;
        //   background: transparent;
        //   border: none;
        //   font-size: 20px;
        //   font-weight: 500;
        //   cursor: pointer;
        //   color: #111;
        //   transition: color 0.2s;
        // }
        
        // .bonus{
        //     background: none;
        //     border: none;
        //     color: #007bff; /* blue text */
        //     font-weight: 600;
        //     cursor: pointer;
        //     position: absolute;
        //     right: 20px;
        //     top: 45px;
        //     transition: color 0.3s ease;
        //     margin-top: auto;
        // }

       

        //   .table-container {
        //     // bottom: 60px;
        //     max-height: 229px; /* set the height you want */
        //     overflow-y: auto;
        //     // border: 1px solid #ddd;
        //     border-radius: 8px;
        //   }

          

        //   .bonus-table {
        //     width: 100%;
        //     border-collapse: collapse;
        //     background-color: white;
        //   }

        //   .bonus-table th,
        //   .bonus-table td {
        //     border: 1px solid #ddd;
        //     text-align: center;
        //     padding: 8px;
        //     background-color: white;
        //     color: #333;
        //     font-size: 14px;
        //   }

        //   .bonus-table th {
        //     position: sticky;
        //     top: 0;
        //     background-color: #f8f9fa;
        //     font-weight: 600;
        //   }

        
        // @media (max-width: 768px) {
        //   .min-h200 {
        //     min-height: 200px;
        //   }

        //   .wallet-row {
        //     // text-decration:none;
        //     top:10px;
        //     flex-wrap: wrap; /* prevent stacking */
        //     gap: 5px;
        //     // height: 100px;
        //   }

        //   .wallet-row.mb-4 {
        //     flex-wrap: nowrap; /* prevent stacking */
        //     gap: 5px;
        //     // height: 100px;
        //   }


        //   .col-lg-6,
        //   .wallet-col-6 {
        //     max-width: 100%;
        //     // flex: 1 1 100%;
        //      flex-direction: column;
        //   }

        //   .ico_iconbox_icon_left {
        //     flex-direction: column;
        //     // padding: 30px;
        //     // width:70%;
        //     display: flex;
        //     font-size: 14px;
        //     // justify-content: space-between;
        //     height: 100%;
        //   }

        //   .ico_iconbox_icon_left h3{
        //   // text-align:center;
        //     font-size: 12px;

        //   }

        //   .bonus {
        //     bottom: -60px;
        //     // top: 110px;
        //     right: 31px;
        //     font-size: 14px;
        //   }

        //   .closes-btn {
        //     top: 37px;
        //     right: 8px;
        //     font-size: 10px;
        //   }

        //   .heading {
        //     top: 20px;
        //     // font-size: 16px;
        //     margin-left: 10px;
        //     font-size: 10px;
        //   }

        //   .bonus-table th,
        //   .bonus-table td {
        //     font-size: 9px;
        //     padding: 6px;
        //   }

        //   .table-container {
        //     max-height: 180px;
        //     overflow-x: auto;
        //     -webkit-overflow-scrolling: touch; 
        //   }

        //   .wallet-row.mb-3 {
        //     margin-left: 0;
        //     margin-right: 0;
        //     // flex-wrap: nowrap;
        //     display: flex;       /* flex container */
        //     flex-wrap: nowrap;   /* keep both cards in one row */
        //     gap: 10px;           /* space between cards */
        //     align-items: stretch; /

        //   }

          

        //   .wallet-row.mb-3 > .wallet-box {
        //     flex: 1 1 50%; /* each card takes half width */
        //     max-width: 50%;
        //     display: flex;
        //     flex-direction: column;
        //     height: 200px; /* make heights equal */
        //     box-sizing: border-box;
        //   }

        //   /* Add outer spacing to cards but keep them side by side */
        //   .wallet-row.mb-3 > .wallet-box:first-child {
        //     padding-left: 0.1px;  /* space on left of Unit Wallet */
        //     padding-right: 0px;  /* small inner gap */
        //   }

        //   .wallet-row.mb-3 > .wallet-box:last-child {
        //     padding-left: 0px;   /* small inner gap */
        //     padding-right: 0.2px; /* space on right of Cash Wallet */
        //   }

        //   /* Make both cards take full height of row */
        //   .wallet-row.mb-3 > .wallet-box {
        //     width: 50%;
        //     box-sizing: border-box;
        //     // height: 100%;
        //     // padding:30px
        //   }
        // }
        // @media (min-width: 769px) {
        //   .min-h200 {
        //     min-height: 120px;
        //   }
        // }
      `}</style>
    </section>
  );
};

export default MyWallet;